export type Language = 'ar' | 'en' | 'fr';

export const translations = {
  ar: {
    nav: {
      features: 'الميزات',
      howItWorks: 'كيف يعمل',
      pricing: 'الأسعار',
      testimonials: 'آراء العملاء',
      startNow: 'ابدأ الآن',
      featuresMenu: [
        {
          title: 'المتجر الإلكتروني',
          description: 'حوّل متجرك إلى متجر إلكتروني ناجح'
        },
        {
          title: 'نقاط البيع (الكاشير)',
          description: 'نظام كاشير احترافي متكامل مع متجرك'
        },
        {
          title: 'الثيمات',
          description: 'صمّم متجرك على وجهتك'
        },
        {
          title: 'نقاط البيع (الكاشير)',
          description: 'أدر عملياتك من لوحة تحكّم واحدة'
        },
        {
          title: 'المدفوعات',
          description: 'استقبل وادر مدفوعاتك بكل سهولة'
        },
        {
          title: 'الشحن',
          description: 'حلول شحن ذكية تناسب تجارتك'
        },
        {
          title: 'التمويل',
          description: 'تمويل فوري لتنمو تجارتك'
        },
        {
          title: 'أدوات التسويق',
          description: 'حوّل متجرك لوجهة تجذب العملاء'
        },
        {
          title: 'إدارة المخزون',
          description: 'إدارة مخزونك بكل كفاءة وسهولة'
        }
      ],
      howItWorksMenu: [
        {
          title: 'إنشاء حساب',
          description: 'سجّل مجاناً في دقائق معدودة'
        },
        {
          title: 'اختيار الباقة',
          description: 'اختر الباقة التي تناسب احتياجاتك'
        },
        {
          title: 'تصميم المتجر',
          description: 'خصّص تصميم متجرك بسهولة'
        },
        {
          title: 'إضافة المنتجات',
          description: 'أضف منتجاتك بكل سهولة وسرعة'
        },
        {
          title: 'إعداد الدفع والشحن',
          description: 'فعّل طرق الدفع والشحن المناسبة'
        },
        {
          title: 'إطلاق المتجر',
          description: 'أطلق متجرك للعملاء وابدأ البيع'
        },
        {
          title: 'إدارة الطلبات',
          description: 'تتبّع وأدر طلباتك بكفاءة'
        },
        {
          title: 'تتبع الأداء',
          description: 'راقب مبيعاتك وحلّل بياناتك'
        },
        {
          title: 'النمو والتوسع',
          description: 'نمّي تجارتك مع أدواتنا المتطورة'
        }
      ],
      supportMenu: [
        {
          title: 'مركز المساعدة',
          description: 'دليل شامل لاستخدام منصة eCommaps'
        },
        {
          title: 'التواصل مع الدعم',
          description: 'فريقنا جاهز للإجابة على استفساراتك'
        },
        {
          title: 'الأسئلة الشائعة',
          description: 'إجابات سريعة للأسئلة الأكثر شيوعاً'
        },
        {
          title: 'أكاديمية eCommaps',
          description: 'تعلم استراتيجيات التجارة الإلكترونية'
        },
        {
          title: 'مجتمع التجار',
          description: 'تواصل مع تجار آخرين وشارك خبراتك'
        },
        {
          title: 'المدونة',
          description: 'مقالات وأخبار حول التجارة الإلكترونية'
        },
        {
          title: 'دليل البدء السريع',
          description: 'ابدأ متجرك في خطوات بسيطة'
        },
        {
          title: 'مكتبة الفيديو',
          description: 'شروحات مرئية لجميع الميزات'
        },
        {
          title: 'أدوات ونماذج',
          description: 'موارد مجانية لنجاح متجرك'
        }
      ],
      support: 'المساعدة والدعم'
    },
    hero: {
      description: 'إيكومابس هو حل شامل للتجارة الإلكترونية قُدم لتمكين التجار وأصحاب المشاريع من بدء إطلاق وإدارة متاجرهم الإلكترونية بكفاءة ويسر. يتميز بتقديم واجهة استخدام مبسطة تتيح إنشاء وتصميم المتجر الإلكتروني بسهولة مع خيارات تخصيص متعددة تلبي احتياجات العلامات التجارية المختلفة. يدمج إيكومابس حلول الـدفـع المختلفة بأدوات تسويقية وتحليلية متطورة تضمن من أداء المبيعات وتعزر تجربة العميل.',
      cta: 'ابدأ متجرك الآن - مجاناً',
      badge: 'الإصدار الجديد 2.0 متاح الآن'
    },
    trustedBy: {
      title: 'موثوق به من قبل رواد الصناعة'
    },
    productShowcase: {
      title: 'منصة واحدة، إمكانيات لا حصر لها',
      subtitle: 'تنقل بسلاسة بين التصميم، الإدارة، والتحليلات لنمو أسرع.',
      tabs: {
        builder: 'المصمم المرئي',
        dashboard: 'لوحة التحكم',
        analytics: 'تحليلات متقدمة'
      },
      cards: {
        builder: {
          title: 'مصمم مرئي متطور',
          description: 'تحكم في كل بكسل مع أدوات السحب والإفلات المتقدمة. لا حاجة لخبرة برمجية.',
          features: [
            'واجهة سحب وإفلات',
            'معاينة حية فورية',
            '100+ قالب احترافي'
          ]
        },
        dashboard: {
          title: 'نظام إدارة شامل',
          description: 'تتبع طلباتك، مخزونك، وعملائك من مكان واحد مركزي وبكل سهولة.',
          features: [
            'تتبع الطلبات لحظياً',
            'إدارة مخزون ذكية',
            'قاعدة بيانات العملاء'
          ]
        },
        analytics: {
          title: 'تقارير وتحليلات دقيقة',
          description: 'اتخذ قرارات مدروسة بناءً على بيانات دقيقة حول أداء متجرك ومبيعاتك.',
          features: [
            'تقارير المبيعات اليومية',
            'تحليل سلوك الزوار',
            'توقعات النمو'
          ]
        }
      }
    },
    features: {
      design: {
        title: 'تصميم متاجر احترافي',
        description: 'صمم متجرك بسهولة ومثّل ما تُحب'
      },
      marketing: {
        title: 'أدوات التسويق',
        description: 'ارفع مبيعاتك مع حلول تسويقية متعددة'
      },
      marketplace: {
        title: 'سوق الحملة الذكي',
        description: 'سوق واحد يجمع البائع بالعزبون'
      },
      affiliate: {
        title: 'التسويق بالعمولة',
        description: 'زد مبيعاتك عبر التسويق بالعمولة'
      },
      network: {
        title: 'شبكة الأكترونين',
        description: 'أعلن عن منتجك مع الفرار التشهير في قطاعك'
      },
      payments: {
        title: 'الدفوعات',
        description: 'إدارة مالية متكاملة لتجارتك وتوفر طرق دفع مرنة'
      },
      inventory: {
        title: 'إدارة المُخزون',
        description: 'إدارة شاملة للمخزون وتوفر الخدمات اللوجستية'
      },
      partners: {
        title: 'الشركاء',
        description: 'الربط والوصول الفوري إلى الشركاء لوجستي الحنترفين'
      }
    },
    howItWorks: {
      title: 'كيف تبدأ مع',
      subtitle: 'ثلاث خطوات بسيطة لإطلاق متجرك الإلكتروني',
      step1: {
        title: 'أنشئ متجرك',
        description: 'سجّل حسابك وأنشئ متجرك الإلكتروني في دقائق معدودة'
      },
      step2: {
        title: 'أضف منتجاتك',
        description: 'ارفع صور منتجاتك وأضف الأوصاف والأسعار بسهولة'
      },
      step3: {
        title: 'ابدأ البيع',
        description: 'ابدأ في استقبال الطلبات وتنمية مبيعاتك'
      }
    },
    advancedFeatures: {
      title: 'ميزات متقدمة لنجاح متجرك',
      customization: {
        title: 'تخصيص كامل لمتجرك',
        description: 'خصص متجرك بالكامل ليعكس هوية علامتك التجارية مع قوالب احترافية وأدوات تصميم سهلة الاستخدام'
      },
      analytics: {
        title: 'تحليلات ذكية',
        description: 'احصل على رؤى عميقة حول أداء متجرك مع لوحة تحكم تحليلية متقدمة وتقارير مفصلة'
      },
      mobile: {
        title: 'تطبيق موبايل متكامل',
        description: 'أدر متجرك من أي مكان مع تطبيق الهاتف المحمول المتكامل والمتزامن مع لوحة التحكم'
      },
      seo: {
        title: 'محرك بحث محسّن',
        description: 'احصل على ترتيب أفضل في نتائج البحث مع أدوات SEO متقدمة مدمجة في المنصة'
      },
      multiChannel: {
        title: 'البيع مُتعدد القنوات',
        description: 'اربط متجرك مع منصات التواصل الاجتماعي والأسواق الإلكترونية الأخرى'
      },
      automation: {
        title: 'الأتمتة الذكية',
        description: 'وفر وقتك مع أدوات الأتمتة الذكية لإدارة الطلبات والمخزون والشحن'
      }
    },
    stats: {
      title: 'أرقامنا تتحدث',
      merchants: {
        number: '5000+',
        label: 'تاجر نشط'
      },
      orders: {
        number: '100,000+',
        label: 'طلب شهرياً'
      },
      revenue: {
        number: '50M+',
        label: 'دينار جزائري مبيعات'
      },
      satisfaction: {
        number: '98%',
        label: 'رضا العملاء'
      }
    },
    pricing: {
      title: 'باقات مرنة تناسب احتياجاتك',
      subtitle: 'اختر الباقة المناسبة لحجم عملك',
      heroTitle: 'باقات التسعير والميزات',
      heroSubtitle: 'اختر الخطة المثالية لبدء أو تطوير تجارتك الإلكترونية',
      monthly: 'شهرياً',
      yearly: 'سنوياً',
      save20: 'وفر 20%',
      starter: {
        name: 'المبتدئ',
        price: 'مجاناً',
        description: 'مثالي للبداية',
        features: [
          'حتى 50 منتج',
          'نطاق فرعي مجاني',
          'دعم فني أساسي',
          'تقارير أساسية',
          'نسبة عمولة 3%'
        ]
      },
      pro: {
        name: 'المحترف',
        price: '2,500 دج/شهر',
        description: 'الأكثر شعبية',
        features: [
          'منتجات غير محدودة',
          'نطاق مخصص مجاني',
          'دعم فني متقدم 24/7',
          'تحليلات متقدمة',
          'نسبة عمولة 1.5%',
          'تطبيق موبايل'
        ],
        popular: true
      },
      enterprise: {
        name: 'المؤسسات',
        price: 'حسب الطلب',
        description: 'للشركات الكبيرة',
        features: [
          'كل ميزات المحترف',
          'مدير حساب مخصص',
          'تكامل مخصص',
          'تدريب فريقك',
          'بدون عمولة',
          'حلول مخصصة'
        ]
      },
      comparison: {
        title: 'قارن بين الباقات',
        subtitle: 'اختر الباقة التي تناسب احتياجاتك',
        features: {
          products: 'عدد المنتجات',
          domain: 'النطاق الخاص',
          support: 'الدعم الفني',
          analytics: 'ال��حليلات',
          commission: 'نسبة العمولة',
          mobileApp: 'تطبيق الموبايل',
          storage: 'مساحة التخزين',
          bandwidth: 'نقل البيانات',
          ssl: 'شهادة SSL',
          seo: 'أدوات SEO',
          marketing: 'أدوات التسويق',
          multiLanguage: 'دعم متعدد اللغات',
          inventory: 'إدارة المخزون',
          shipping: 'تكامل الشحن',
          payments: 'طرق الدفع',
          reports: 'التقارير المتقدمة',
          api: 'API Access',
          customization: 'التخصيص الكامل'
        },
        values: {
          free: {
            products: 'حتى 50',
            domain: 'نطاق فرعي',
            support: 'بريد إلكتروني',
            analytics: 'أساسي',
            commission: '3%',
            mobileApp: false,
            storage: '1 GB',
            bandwidth: '10 GB/شهر',
            ssl: true,
            seo: 'أساسي',
            marketing: 'محدود',
            multiLanguage: true,
            inventory: 'أساسي',
            shipping: 'محدود',
            payments: '2 طرق',
            reports: 'أساسي',
            api: false,
            customization: 'محدود'
          },
          pro: {
            products: 'غي�� محدود',
            domain: 'مجاني',
            support: '24/7 دردشة وهاتف',
            analytics: 'متقدم',
            commission: '1.5%',
            mobileApp: true,
            storage: '20 GB',
            bandwidth: 'غير محدود',
            ssl: true,
            seo: 'متقدم',
            marketing: 'كامل',
            multiLanguage: true,
            inventory: 'متقدم',
            shipping: 'كامل',
            payments: 'غير محدود',
            reports: 'متقدم',
            api: true,
            customization: 'كامل'
          }
        }
      },
      faq: {
        title: 'الأسئلة الشائعة',
        subtitle: 'كل ما تحتاج معرفته عن باقاتنا',
        questions: [
          {
            q: 'هل يمكنني تغيير الباقة لاحقاً؟',
            a: 'نعم، يمكنك الترقية أو التخفيض في أي وقت. سيتم احتساب الفرق في السعر بشكل تناسبي.'
          },
          {
            q: 'ما هي طرق الدفع المتاحة؟',
            a: 'نقبل الدفع عبر البطاقات البنكية، CCP، Baridi Mob، والتحويل البنكي المباشر.'
          },
          {
            q: 'هل توجد عمولة إضافية على المبيعات؟',
            a: 'الباقة المجانية تتضمن عمولة 3%، المحترف 1.5%، والمؤسسات بدون عمولة.'
          },
          {
            q: 'هل يمكنني إلغاء الاشتراك في أي وقت؟',
            a: 'نعم، يمكنك إلغاء الاشتراك في أي وقت دون أي رسوم إضافية. ستحتفظ بالوصول حتى نهاية فترة الاشتراك.'
          },
          {
            q: 'هل التدريب متضمن في الباقة؟',
            a: 'جميع الباقات تتضمن دروس فيديو ومقالات تعليمية. باقة المؤسسات تشمل تدريب مباشر لفريقك.'
          },
          {
            q: 'ما هي مدة الاشتراك المجاني؟',
            a: 'الباقة المجانية لا تحتاج لبطاقة ائتمان ويمكنك استخدامها بدون حد زمني. الترقية متاحة في أي وقت.'
          }
        ]
      },
      cta: 'ابدأ الآن',
      ctaSecondary: 'تواصل مع المبيعات',
      perMonth: 'شهرياً',
      popularBadge: 'الأكثر شعبية',
      whyChoose: {
        title: 'لماذا تختار eCommaps؟',
        subtitle: 'كل ما تحتاجه لنجاح متجرك الإلكتروني في مكان واحد',
        reasons: [
          {
            title: 'سهولة الاستخدام',
            description: 'واجهة بسيطة وسهلة لا تحتاج لخبرة تقنية'
          },
          {
            title: 'دعم محلي',
            description: 'فريق دعم يتحدث العربية متاح 24/7'
          },
          {
            title: 'طرق دفع جزائرية',
            description: 'تكامل مع CCP، Baridi Mob وكل الطرق المحلية'
          },
          {
            title: 'شحن محلي',
            description: 'شراكات مع أفضل شركات الشحن في الجزائر'
          },
          {
            title: 'تحديثات مستمرة',
            description: 'ميزات جديدة وتحسينات دورية مجانية'
          },
          {
            title: 'أمان عالي',
            description: 'حماية متقدمة لبياناتك وبيانات عملائك'
          }
        ]
      },
      finalCta: {
        title: 'هل أنت مستعد للبدء؟',
        subtitle: 'انضم إلى آلاف التجار الذين يثقون في eCommaps لإدارة متاجرهم الإلكترونية',
        button: 'ابدأ مجاناً الآن'
      }
    },
    testimonials: {
      title: 'ماذا يقول عملاؤنا',
      subtitle: 'آلاف التجار يثقون في Ecommaps.com',
      reviews: [
        {
          name: 'أحمد بن علي',
          role: 'صاحب متجر الكتروني',
          content: 'إيكومابس غيّر حياتي! استطعت إطلاق متجري في أقل من ساعة والآن أبيع منتجاتي لكل الجزائر. المنصة سهلة جداً وفريق الدعم رائع.',
          rating: 5
        },
        {
          name: 'فاطمة الزهراء',
          role: 'مصممة أزياء',
          content: 'أفضل منصة للتجارة الإلكترونية في الجزائر! الأدوات التسويقية ساعدتني في مضاعفة مبيعاتي خلال شهرين فقط.',
          rating: 5
        },
        {
          name: 'محمد الأمين',
          role: 'تاجر جملة',
          content: 'التكامل مع أنظمة الدفع والشحن وفر علي الكثير من الوقت. الآن أركز على تطوير منتجاتي والمنصة تهتم بالباقي.',
          rating: 5
        }
      ]
    },
    cta: {
      title: 'ابدأ رحلتك في التجارة الإلكترونية اليوم',
      subtitle: 'انضم إلى مئات التجار الذين يثقون في ecommaps.com لإدارة متاجرهم الإلكترونية',
      primaryButton: 'ابدأ تجربتك المجانية',
      secondaryButton: 'تواصل معنا'
    },
    footer: {
      description: 'منصة التجارة الإلكترونية الأولى في الجزائر لدعم التجار وأصحاب المشاريع',
      quickLinks: 'روابط سريعة',
      support: 'الدعم',
      contact: 'تواصل معنا',
      helpCenter: 'مركز المساعدة',
      faq: 'الأسئلة الشائعة',
      terms: 'شروط الخدمة',
      privacy: 'سياسة الخصوصية',
      aboutUs: 'من نحن',
      blog: 'المدونة',
      copyright: 'جميع الحقوق محفوظة | جزء من مجموعة LaboBank Holding'
    },
    verifyEmail: {
      title: 'أدخل رمز التحقق',
      sentTo: 'تم إرسال رمز التحقق إلى بريدك الإلكتروني',
      enterCode: 'أدخل الرمز المكون من 6 أرقام',
      resendCode: 'إعادة إرسال الكود',
      verify: 'التحقق الآن',
      timer: 'إعادة الإرسال متاحة بعد',
      seconds: 'ثانية',
      success: 'تم التحقق بنجاح!',
      redirecting: 'جاري تحويلك إلى لوحة التحكم...',
      error: 'الرمز غير صحيح، يرجى المحاولة مرة أخرى',
      codeResent: 'تم إعادة إرسال الرمز بنجاح',
      backToLogin: 'العودة إلى تسجيل الدخول',
      verifying: 'جاري التحقق...'
    },
    verifyLogin: {
      title: 'التحقق من تسجيل الدخول',
      sentTo: 'تم إرسال رمز التحقق إلى بريدك الإلكتروني',
      enterCode: 'أدخل الرمز المكون من 6 أرقام للمتابعة',
      resendCode: 'إعادة إرسال الكود',
      verify: 'تسجيل الدخول',
      timer: 'إعادة الإرسال متاحة بعد',
      seconds: 'ثانية',
      success: 'تم التحقق بنجاح!',
      redirecting: 'جاري تحويلك إلى لوحة التحكم...',
      error: 'الرمز غير صحيح، يرجى المحاولة مرة أخرى',
      codeResent: 'تم إعادة إرسال الرمز بنجاح',
      backToLogin: 'العودة إلى تسجيل الدخول',
      verifying: 'جاري التحقق...',
      securityMessage: 'نحن نحمي حسابك من خلال التحقق بخطوتين'
    },
    dashboard: {
      title: 'لوحة التحكم',
      welcome: 'مرحباً بك',
      subtitle: 'أدِر متاجرك وتتبع مبيعاتك من مكان واحد',
      merchant: 'تاجر',
      user: 'المستخدم',
      profile: {
        merchantAccount: 'حساب التاجر',
        manageProfile: 'إدارة الملف الشخصي',
        settings: 'الإعدادات',
        editSettings: 'تعديل الإعدادات',
        logout: 'تسجيل الخروج'
      },
      stats: {
        stores: 'المتاجر',
        orders: 'الطلبات',
        products: 'المنتجات',
        revenue: 'الإيرادات'
      },
      stores: {
        title: 'متاجرك',
        createNew: 'إنشاء متجر جديد',
        noStores: 'لا توجد متاجر بعد',
        createFirst: 'أنشئ متجرك الأول وابدأ البيع!',
        viewStore: 'معاينة المتجر',
        manageStore: 'إدارة المتجر',
        noDescription: 'لا يوجد وصف',
        active: 'نشط',
        inactive: 'غير نشط'
      },
      settings: {
        title: 'الإعدادات',
        personalSettings: 'الإعدادات الشخصية',
        subtitle: 'أدر حسابك وتفضيلاتك',
        backToDashboard: 'العودة للوحة التحكم',
        profile: {
          title: 'الملف الشخصي',
          fullName: 'الاسم الكامل',
          email: 'البريد الإلكتروني',
          emailNote: 'لا يمكن تغيير البريد الإلكتروني',
          saveChanges: 'حفظ التغييرات',
          phone: 'رقم الهاتف'
        },
        business: {
          title: 'معلومات العمل',
          companyName: 'اسم الشركة',
          phone: 'رقم الهاتف',
          phoneDescription: 'سيتم استخدامه لإشعارات الطلبات',
          rc: 'السجل التجاري (RC)',
          nif: 'الرقم الضريبي (NIF)',
          nis: 'الرقم الإحصائي (NIS)',
          art: 'رقم المادة (ART)',
          saveInfo: 'حفظ معلومات العمل'
        },
        exchangeRates: {
          title: 'أسعار الصرف',
          subtitle: 'إدارة وتخصيص أسعار الصرف لحسابك لجميع المتاجر',
          baseCurrency: 'العملة الأساسية',
          targetCurrency: 'العملة المستهدفة',
          rate: 'سعر الصرف',
          active: 'الحالة',
          autoUpdate: 'تلقائي',
          manualEntry: 'يدوي',
          addRate: 'إضافة سعر مخصص',
          saveChanges: 'حفظ التغييرات',
          delete: 'حذف',
          dialogTitle: 'إضافة سعر صرف مخصص',
        },
        appearance: {
          title: 'المظهر',
          subtitle: 'تخصيص شكل لوحة التحكم',
          theme: 'السمة',
          light: 'فاتح',
          dark: 'داكن',
          system: 'النظام',
          themeDescription: 'اختر السمة المناسبة للوحة التحكم'
        },
        billing: {
          title: 'الفوترة',
          badge: 'قريباً'
        },
        notifications: {
          title: 'الإشعارات',
          newOrders: 'إشعارات الطلبات الجديدة',
          newOrdersDesc: 'تلقي إشعار عند ورود طلب جديد',
          productUpdates: 'تحديثات المنتجات',
          productUpdatesDesc: 'إشعارات حول تحديثات المخزون والمنتجات',
          weeklyReports: 'التقارير الأسبوعية',
          weeklyReportsDesc: 'تلقي ملخص أسبوعي للمبيعات والأداء',
          marketing: 'رسائل التسويق',
          marketingDesc: 'نصائح وعروض خاصة'
        },
        security: {
          title: 'الأمان',
          changePassword: 'تغيير كلمة المرور',
          newPassword: 'كلمة المرور الجديدة',
          confirmPassword: 'تأكيد كلمة المرور الجديدة',
          updatePassword: 'تحديث كلمة المرور',
          updating: 'جاري التحديث...',
          passwordNote: 'ملاحظة: لن تحتاج إلى إدخال كلمة المرور الحالية - فقط اكتب كلمة المرور الجديدة',
          twoFactor: 'المصادقة الثنائية',
          twoFactorDesc: 'أضف طبقة أمان إضافية لحسابك',
          twoFactorComing: 'قريباً - تفعيل المصادقة الثنائية'
        },
        currentInfo: {
          title: 'المعلومات الحالية',
          fullName: 'الاسم الكامل',
          email: 'البريد الإلكتروني',
          phone: 'رقم الهاتف',
          lastUpdate: 'آخر تحديث',
          notSet: 'غير محدد',
          notAvailable: 'غير متوفر'
        },
        quickLinks: {
          analytics: 'التحليلات',
          settings: 'الإعدادات',
          domains: 'النطاقات',
          marketing: 'التسويق'
        }
      },
      storeDashboard: {
        title: 'إدارة المتجر',
        overview: 'نظرة عامة',
        pages: 'الصفحات',
        products: 'المنتجات',
        orders: 'الطلبات',
        analytics: 'التحليلات',
        settings: 'إعدادات المتجر',
        viewStore: 'معاينة المتجر',
        editPage: 'تعديل الصفحة',
        createPage: 'إنشاء صفحة جديدة',
        manageProducts: 'إدارة المنتجات',
        addProduct: 'إضافة منتج',
        viewOrders: 'عرض الطلبات',
        storeSettings: 'إعدادات',
        storeName: 'اسم المتجر',
        storeDescription: 'وصف المتجر',
        storeLogo: 'شعار المتجر',
        contactInfo: 'معلومات التواصل',
        socialLinks: 'روابط وسائل التواصل',
        saveSettings: 'حفظ الإعدادات',
        noPages: 'لا توجد صفحات بعد',
        createFirstPage: 'أنشئ صفحتك الأولى باستخدام محرر السحب والإفلات',
        delete: 'حذف',
        edit: 'تعديل',
        startSelling: 'ابدأ البيع',
        shareStore: 'شارك رابط متجرك وابدأ استقبال الطلبات',
        pagesSection: {
          title: 'صفحات المتجر',
          subtitle: 'أنشئ وعدّل صفحات متجرك باستخدام محرر السحب والإفلات',
          newPage: 'صفحة جديدة',
          tableHeaders: {
            title: 'العنوان',
            slug: 'الرابط',
            status: 'الحالة',
            lastUpdate: 'آخر تحديث',
            actions: 'الإجراءات'
          },
          published: 'منشور',
          draft: 'مسودة'
        },
        quickStart: {
          title: '🚀 دليل البدء السريع',
          steps: [
            { title: 'أنشئ الصفحة الرئيسية', desc: 'استخدم المحرر المرئي لتصميم واجهة متجرك' },
            { title: 'أضف منتجاتك', desc: 'أضف منتجاتك مع الصور والأسعار' },
            { title: 'ابدأ البيع', desc: 'شارك رابط متجرك وابدأ استقبال الطلبات' }
          ]
        }
      },
      editor: {
        title: 'محرر الصفحات',
        save: 'حفظ',
        publish: 'نشر',
        preview: 'معاينة',
        saved: 'تم الحفظ',
        publishing: 'جاري النشر...',
        published: 'تم النشر',
        viewLive: 'عرض المتجر',
        backToPages: 'العودة للصفحات',
        components: 'المكونات',
        addComponent: 'إضافة مكون',
        editComponent: 'تعديل المكون',
        deleteComponent: 'حذف المكون',
        aiGenerate: 'توليد بالذكاء الاصطناعي',
        generating: 'جاري التوليد...'
      },
      themes: {
        title: 'الثيمات',
        subtitle: 'اختر تصميم متجرك',
        browse: 'تصفح الثيمات',
        current: 'الثيم الحالي',
        preview: 'معاينة',
        apply: 'تطبيق',
        customize: 'تخصيص',
        colors: 'الألوان',
        fonts: 'الخطوط',
        layout: 'التخطيط',
        advanced: 'متقدم',
        saveChanges: 'حفظ التغييرات',
        resetToDefault: 'إعادة تعيين للافتراضي'
      },
      marketing: {
        title: 'التسويق',
        subtitle: 'أدوات لتنمية متجرك',
        campaigns: 'الحملات الإعلانية',
        coupons: 'الكوبونات والخصومات',
        emailMarketing: 'التسويق عبر البريد',
        seo: 'تحسين محركات البحث',
        socialMedia: 'وسائل التواصل الاجتماعي',
        createCampaign: 'إنشاء حملة جديدة',
        createCoupon: 'إنشاء كوبون',
        viewReports: 'عرض التقارير',
        analytics: 'تحليلات التسويق'
      },
      sidebar: {
        dashboard: 'لوحة التحكم',
        products: 'المنتجات',
        orders: 'الطلبات',
        analytics: 'التحليلات',
        marketing: 'التسويق',
        settings: 'الإعدادات',
        pageEditor: 'محرر الصفحات',
        storeManagement: 'إدارة المتجر',
        backToDashboard: 'العودة للوحة الرئيسية'
      }
    },
    createStore: {
      hero: {
        badge: 'أنشئ متجرك الإلكتروني في دقائق',
        title: 'أنشئ متجرك الإلكتروني بأسهل طريقة',
        subtitle: 'بدون برمجة، بدون تعقيد - متجرك الاحترافي جاهز في دقائق معدودة',
        cta: 'ابدأ مجاناً الآن',
        learnMore: 'اكتشف المزيد',
        stats: [
          { number: '5 دقائق', label: 'لإنشاء متجرك' },
          { number: 'بدون برمجة', label: 'سهل وبسيط' },
          { number: '5000+', label: 'تاجر نشط' },
          { number: '24/7', label: 'دعم فني' }
        ]
      },
      multilingual: {
        title: 'تحدث بلغة عملائك',
        description: 'متجرك متوفر بثلاث لغات (عربي، إنجليزي، فرنسي) للوصول لأكبر شريحة من العملاء في الجزائر والعالم العربي',
        features: [
          'واجهة متعددة اللغات تلقائياً',
          'ترجمة احترافية لجميع عناصر المتجر',
          'تبديل سلس بين اللغات',
          'دعم كامل للغة العربية (RTL)'
        ]
      },
      existingStore: {
        title: 'هل لديك متجر بالفعل؟',
        description: 'انقل متجرك الحالي إلى eCommaps بسهولة واستفد من جميع الميزات المتقدمة',
        benefit1: 'نقل سلس لجميع بياناتك ومنتجاتك',
        benefit2: 'احتفظ بعملائك وطلباتك السابقة',
        benefit3: 'دعم فني مجاني لعملية النقل',
        cta: 'ابدأ النقل الآن'
      },
      fullControl: {
        title: 'تح��م في كل شيء',
        subtitle: 'أدر متجرك بالكامل من لوحة تحكم واحدة بسيطة وقوية',
        features: [
          {
            title: 'لوحة تحكم شاملة',
            description: 'أدر جميع جوانب متجرك من مكان واحد بواجهة سهلة الاستخدام'
          },
          {
            title: 'تخصيص كامل للتصميم',
            description: 'اجعل متجرك فريداً مع قوالب احترافية وأدوات تخصيص متقدمة'
          },
          {
            title: 'تقارير وإحصائيات',
            description: 'تتبع أداء متجرك بتقارير مفصلة وتحليلات ذكية'
          }
        ]
      },
      customerForever: {
        title: 'عميلك إلى الأبد',
        description: 'بني علاقات طويلة الأمد مع عملائك من خلال أدوات ذكية لإدارة العملاء والولاء',
        features: [
          'نظام ولاء وبرامج مكافآت',
          'إشعارات ذكية لعودة العملاء',
          'قاعدة بيانات عملاء متقدمة',
          'تسويق مخصص لكل عميل'
        ],
        stat1: 'معدل عودة العملاء',
        stat2: 'تقييم العملاء',
        stat3: 'زيادة في ال��بيعات المتكررة',
        stat4: 'في رضا العملاء'
      },
      featuresGrid: {
        title: 'كل ما تحتاجه في مكان واحد',
        subtitle: 'ميزات متكاملة لإطلاق وإدارة متجر إلكتروني ناجح',
        items: [
          {
            icon: 'clock',
            title: 'إنشاء في دقائق',
            description: 'متجرك جاهز في 5 دقائق فقط'
          },
          {
            icon: 'code',
            title: 'بدون برمجة',
            description: 'لا تحتاج لأي خبرة تقنية'
          },
          {
            icon: 'smartphone',
            title: 'متوافق مع الجوال',
            description: 'متجرك يعمل بشكل مثالي على كل الأجهزة'
          },
          {
            icon: 'palette',
            title: 'قوالب احترافية',
            description: 'مئات القوالب الجاهزة للاستخدام'
          },
          {
            icon: 'shield',
            title: 'أمان عالي',
            description: 'حماية متقدمة لبياناتك وعملائك'
          },
          {
            icon: 'creditCard',
            title: 'دفع إلكتروني',
            description: 'تكامل مع جميع بوابات الدفع'
          },
          {
            icon: 'truck',
            title: 'شحن ذكي',
            description: 'ربط تلقائي مع شركات الشحن'
          },
          {
            icon: 'barChart',
            title: 'تحليلات متقدمة',
            description: 'فهم عميق لأداء متجرك'
          }
        ]
      },
      availableService: {
        title: 'خدمة متوافرة على مدار الساعة',
        description: 'فريق دعم محترف جاهز لمساعدتك في أي وقت',
        services: [
          {
            title: 'دعم فني 24/7',
            description: 'فريقنا متاح دائماً للإجابة على أسئلتك ومساعدتك'
          },
          {
            title: 'مركز تعليمي شامل',
            description: 'مكتبة غنية بالدروس والشروحات المصورة'
          },
          {
            title: 'مجتمع نشط',
            description: 'انضم لآلاف التجار وتبادل الخبرات'
          }
        ],
        supportTitle: 'نحن هنا لمساعدتك',
        supportDescription: 'تواصل معنا عبر الدردشة، الهاتف، أو البريد الإلكتروني',
        contactButton: 'تواصل معنا الآن'
      },
      professionalManagement: {
        title: 'احترف إدارة متجرك',
        subtitle: 'أدوات احترافية لإدارة جميع جوانب متجرك بكفاءة',
        tools: [
          {
            title: 'إدارة المنتجات',
            description: 'أضف وعدل منتجاتك بسهولة مع إدارة متقدمة للمخزون',
            features: [
              'إضافة منتجات غير محدودة',
              'تصنيفات ووسوم ذكية',
              'إدارة المخزون التلقائية',
              'استيراد بالجملة'
            ]
          },
          {
            title: 'إدارة الطلبات',
            description: 'تتبع ومعالجة الطلبات بكفاءة عالية',
            features: [
              'نظام طلبات متطور',
              'إشعارات فورية',
              'تتبع الشحنات',
              'إدارة المرتجعات'
            ]
          },
          {
            title: 'إدارة العملاء',
            description: 'بني علاقات قوية مع عملائك',
            features: [
              'قاعدة بيانات شاملة',
              'تاريخ الطلبات الكامل',
              'برامج الولاء',
              'تقسيم العملاء'
            ]
          }
        ]
      },
      successSteps: {
        title: 'خطوات النجاح',
        subtitle: 'اتبع هذه الخطوات البسيطة لإطلاق متجرك الناجح',
        steps: [
          {
            title: 'سجل حسابك',
            description: 'إنشاء حساب مجاني في ثوانٍ'
          },
          {
            title: 'صمم متجرك',
            description: 'اختر قالباً وخصصه حسب رغبتك'
          },
          {
            title: 'أضف منتجاتك',
            description: 'ارفع منتجاتك وحدد الأسعار'
          },
          {
            title: 'ابدأ البيع',
            description: 'أطلق متجرك واستقبل الطلبات'
          }
        ]
      },
      customerData: {
        title: 'اجمع معلومات عملائك بذكاء',
        description: 'فهم عميق لسلوك عملائك يساعدك على تحسين مبيعاتك وتجربة التسوق',
        benefits: [
          'تحليل شامل لسلوك العملاء',
          'تتبع رحلة الشراء الكاملة',
          'تقارير مفصلة عن الاهتمامات',
          'توصيات ذكية للمنتجات'
        ],
        metric1: 'عميل نشط',
        metric2: 'نمو العملاء',
        metric3: 'معدل الرضا'
      },
      successTools: {
        title: 'أد��ات النجاح في متناول يدك',
        subtitle: 'كل ما تحتاجه لتنمية متجرك وزيادة مبيعاتك',
        tools: [
          {
            icon: 'zap',
            title: 'تسويق ذكي',
            description: 'أدوات تسويقية متقدمة لجذب المزيد من العملاء وزيادة المبيعات'
          },
          {
            icon: 'target',
            title: 'حملات مستهدفة',
            description: 'أنشئ حملات تسويقية دقيقة تصل للجمهور المناسب في الوقت المناسب'
          },
          {
            icon: 'trendingUp',
            title: 'تحسين محركات البحث',
            description: 'أدوات SEO متقدمة لظهور أفضل في نتائج البحث'
          },
          {
            icon: 'shield',
            title: 'أمان مضمون',
            description: 'حماية متعددة الطبقات لبيانات متجرك وعملائك'
          },
          {
            icon: 'users',
            title: 'إدارة الفريق',
            description: 'أضف أعضاء فريقك وحدد صلاحيات الوصول بسهولة'
          },
          {
            icon: 'rocket',
            title: 'نمو مستمر',
            description: 'أدوات وتحديثات مستمرة لمساعدتك على النمو'
          }
        ]
      },
      pricingPreview: {
        title: 'باقات مرنة لكل الاحتياجات',
        subtitle: 'ابدأ مجاناً وترقى حسب نمو متجرك',
        popularBadge: 'الأكثر شعبية',
        plans: [
          {
            name: 'المبتدئ',
            price: 'مجاناً',
            features: [
              'حتى 50 منتج',
              'نطاق فرعي مجاني',
              'دعم فني أساسي',
              'تقارير أساسية'
            ],
            cta: 'ابدأ مجاناً',
            popular: false
          },
          {
            name: 'المحترف',
            price: '2,500 دج/شهر',
            features: [
              'منتجات غير محدودة',
              'نطاق مخصص مجاني',
              'دعم 24/7',
              'تحليلات متقدمة',
              'تطبيق موبايل'
            ],
            cta: 'جرب الآن',
            popular: true
          },
          {
            name: 'المؤسسات',
            price: 'حسب الطلب',
            features: [
              'كل ميزات المحترف',
              'مدير حساب مخصص',
              'تكامل مخصص',
              'بدون عمولة'
            ],
            cta: 'تواصل معنا',
            popular: false
          }
        ],
        viewAll: 'عرض جميع الباقات'
      },
      finalCta: {
        title: 'جاهز لإطلاق متجرك؟',
        subtitle: 'انضم لآلاف التجار الذين اختاروا eCommaps لبناء متاجرهم الإلكترونية الناجحة',
        primaryButton: 'أنشئ متجرك الآن',
        secondaryButton: 'تعرف على المزيد'
      }
    },
    pos: {
      hero: {
        badge: 'نظام نقاط البيع الشامل',
        title: 'حول متجرك التقليدي إلى تجربة رقمية متكاملة',
        subtitle: 'نظام كاشير احترافي متكامل مع متجرك الإلكتروني - إدارة موحدة للمخزون والمبيعات',
        primaryButton: 'ابدأ تجربتك المجانية',
        secondaryButton: 'شاهد العرض التوضيحي',
        stats: [
          { value: '3', label: 'دقائق للتثبيت' },
          { value: '100%', label: 'تزامن تلقائي' },
          { value: '24/7', label: 'دعم فني' },
          { value: '0 د.ج', label: 'رسوم بدء التشغيل' }
        ]
      },
      whyNeed: {
        title: 'لماذا تحتاج نقاط البيع من eCommaps؟',
        subtitle: 'نظام متكامل يجمع ��ين قوة التجارة الإلكترونية وسهولة نقاط البيع التقليدية',
        features: [
          {
            title: 'تزامن فوري مع المتجر الإلكتروني',
            description: 'كل عملية بيع في المتجر تنعكس مباشرة على مخزونك الإلكتروني'
          },
          {
            title: 'إدارة موحدة للمخزون',
            description: 'لا مزيد من الأخطاء - مخزون واحد متزامن بين جميع نقاط البيع'
          },
          {
            title: 'تقارير شاملة ومفصلة',
            description: 'تحليلات دقيقة لمبيعاتك في المتجر والإنترنت من لوحة تحكم واحدة'
          },
          {
            title: 'دعم طرق دفع متعددة',
            description: 'نقداً، بطاقات، محفظة إلكترونية - كل شيء في مكان واحد'
          }
        ]
      },
      features: {
        title: 'ميزات نظام نقاط البيع',
        subtitle: 'كل ما تحتاجه لإدارة متجرك التقليدي باحترافية',
        items: [
          {
            title: 'واجهة سه��ة الاستخدام',
            description: 'تصميم بسيط وسريع يمكن موظفيك من إتقانه في دقائق'
          },
          {
            title: 'طباعة فواتير احترافية',
            description: 'فواتير مخصصة بشعارك وبياناتك التجارية'
          },
          {
            title: 'إدارة العملاء',
            description: 'احفظ بيانات عملائك وبرامج الولاء والخصومات الخاصة'
          },
          {
            title: 'قارئ الباركود',
            description: 'دعم كامل لقارئات الباركود لمسح المنتجات بسرعة'
          },
          {
            title: 'تقارير يومية وشهرية',
            description: 'تقارير مفصلة عن المبيعات والأرباح والمخزون'
          },
          {
            title: 'عمل بدون إنترنت',
            description: 'استمر في البيع حتى بدون اتصال - التزامن التلقائي عند العودة'
          }
        ]
      },
      howToUse: {
        title: 'كيف تبدأ استخدام نظام الكاشير؟',
        subtitle: 'أربع خطوات بسيطة لتشغيل نقطة البيع',
        steps: [
          {
            title: 'قم بتنزيل التطبيق',
            description: 'متاح على الويب، ويندوز، وأندرويد'
          },
          {
            title: 'اربط حسابك',
            description: 'سجل دخولك بنفس حساب متجرك الإلكتروني'
          },
          {
            title: 'اضبط الإعدادات',
            description: 'اختر الطابعة وطريقة الدفع والضريبة'
          },
          {
            title: 'ابدأ البيع',
            description: 'كل شيء جاهز - ابدأ باستقبال عملائك'
          }
        ]
      },
      storeTypes: {
        title: 'مناسب لجميع أنواع المحلات',
        subtitle: 'نظام مرن يتكيف مع احتياجات عملك',
        types: [
          {
            title: 'محلات الملابس',
            description: 'إدارة المقاسات والألوان والموديلات بسهولة'
          },
          {
            title: 'متاجر الإلكترونيات',
            description: 'تتبع الأرقام التسلسلية والضمانات'
          },
          {
            title: 'المقاهي والمطاعم',
            description: 'قوائم طعام وخيارات تخصيص للطلبات'
          },
          {
            title: 'الصيدليات',
            description: 'تتبع تواريخ الصلاحية والوصفات الطبية'
          },
          {
            title: 'محلات الهد��يا',
            description: 'خيارات التغليف والبطاقات'
          },
          {
            title: 'أي نوع آخر',
            description: 'نظام مرن قابل للتخصيص حسب احتياجاتك'
          }
        ]
      },
      integration: {
        title: 'تكامل سلس مع متجرك الإلكتروني',
        subtitle: 'نظام واحد لإدارة جميع قنوات البيع',
        benefits: [
          'مخزون موحد يتحدث تلقائياً',
          'تقارير شاملة لجميع القنوات',
          'بيانات عملاء مركزية',
          'طرق دفع موحدة',
          'حملات تسويقية متكاملة',
          'برامج ولاء موحدة'
        ]
      },
      pricing: {
        title: 'خطط تسعير نظام نقاط البيع',
        subtitle: 'اختر الباقة المناسبة لحجم عملك',
        plans: [
          {
            name: 'الباقة الأساسية',
            price: 'مجاناً',
            period: 'شهرياً',
            description: 'مثالية للمحلات الصغيرة',
            features: [
              'نقطة بيع واحدة',
              'المنتجات غير محدودة',
              'التزامن مع المتجر الإلكتروني',
              'تقا��ير أساسية',
              'دعم فني'
            ]
          },
          {
            name: 'الباقة المتقدمة',
            price: '4,999',
            period: 'شهرياً',
            description: 'للمحلات المتوسطة',
            popular: true,
            features: [
              'حتى 5 نقاط بيع',
              'كل ميزات الباقة الأساسية',
              'تقارير متقدمة',
              'إدارة الموظفين',
              'برامج الولاء',
              'دعم الباركود'
            ]
          },
          {
            name: 'الباقة الاحترافية',
            price: 'حسب الطلب',
            period: '',
            description: 'للمتاجر الكبيرة',
            features: [
              'نقاط بيع غير محدودة',
              'كل ميزات المتقدمة',
              'API مخصص',
              'مدير حساب مخصص',
              'تدريب الفريق',
              'دعم VIP'
            ]
          }
        ]
      },
      testimonials: {
        title: 'ماذا يقول عملاؤنا',
        items: [
          {
            name: 'أحمد بن محمد',
            role: 'صاحب محل ملابس',
            text: 'نظام الكاشير من eCommaps غير طريق�� عملي تماماً. الآن أتحكم في كل شيء من مكان واحد.'
          },
          {
            name: 'فاطمة الزهراء',
            role: 'صاحبة متجر إلكترونيات',
            text: 'التزامن الفوري مع المتجر الإلكتروني وفر علي الكثير من الوقت والأخطاء.'
          },
          {
            name: 'خالد العربي',
            role: 'صاحب مقهى',
            text: 'سهل الاستخدام وسريع. موظفيني تعلموا عليه في أقل من ساعة.'
          }
        ]
      },
      hardware: {
        title: 'الأجهزة المدعومة',
        subtitle: 'يعمل مع معظم أجهزة نقاط البيع المتوفرة في السوق',
        devices: [
          {
            title: 'طابعات الفواتير',
            description: 'دعم جميع الطابعات الحرارية 80mm و 58mm'
          },
          {
            title: 'قارئات الباركود',
            description: 'متوافق مع جميع قارئات USB و Bluetooth'
          },
          {
            title: 'أدراج النقود',
            description: 'يفتح تلقائياً بعد كل عملية بيع نقدية'
          },
          {
            title: 'أجهزة الدفع',
            description: 'متكامل مع أشهر أجهزة الدفع الإلكتروني'
          }
        ]
      },
      finalCta: {
        title: 'جاهز لتحويل متجرك إلى تجربة رقمية؟',
        subtitle: 'ابدأ تجربتك المجانية اليوم ولا تحتاج لبطاقة ائتمان',
        primaryButton: 'ابدأ تجربتك المجانية',
        secondaryButton: 'تحدث مع خبير'
      }
    }
  },
  en: {
    nav: {
      features: 'Features',
      howItWorks: 'How It Works',
      pricing: 'Pricing',
      testimonials: 'Testimonials',
      startNow: 'Start Now',
      featuresMenu: [
        {
          title: 'Online Store',
          description: 'Turn your store into a successful online business'
        },
        {
          title: 'POS (Point of Sale)',
          description: 'Professional POS system integrated with your store'
        },
        {
          title: 'Themes',
          description: 'Design your store your way'
        },
        {
          title: 'Point of Sale (POS)',
          description: 'Manage your operations from one control panel'
        },
        {
          title: 'Payments',
          description: 'Receive and manage your payments easily'
        },
        {
          title: 'Shipping',
          description: 'Smart shipping solutions for your business'
        },
        {
          title: 'Financing',
          description: 'Instant financing to grow your business'
        },
        {
          title: 'Marketing Tools',
          description: 'Turn your store into a customer magnet'
        },
        {
          title: 'Inventory Management',
          description: 'Manage your inventory efficiently and easily'
        }
      ],
      howItWorksMenu: [
        {
          title: 'Create Account',
          description: 'Sign up for free in minutes'
        },
        {
          title: 'Choose Plan',
          description: 'Select the plan that fits your needs'
        },
        {
          title: 'Design Store',
          description: 'Customize your store design easily'
        },
        {
          title: 'Add Products',
          description: 'Add your products quickly and easily'
        },
        {
          title: 'Setup Payment & Shipping',
          description: 'Enable suitable payment and shipping methods'
        },
        {
          title: 'Launch Store',
          description: 'Launch your store to customers and start selling'
        },
        {
          title: 'Manage Orders',
          description: 'Track and manage your orders efficiently'
        },
        {
          title: 'Track Performance',
          description: 'Monitor your sales and analyze your data'
        },
        {
          title: 'Grow & Expand',
          description: 'Grow your business with our advanced tools'
        }
      ],
      supportMenu: [
        {
          title: 'Help Center',
          description: 'Comprehensive guide for using eCommaps platform'
        },
        {
          title: 'Contact Support',
          description: 'Our team is ready to answer your questions'
        },
        {
          title: 'FAQ',
          description: 'Quick answers to the most common questions'
        },
        {
          title: 'eCommaps Academy',
          description: 'Learn e-commerce strategies and best practices'
        },
        {
          title: 'Merchant Community',
          description: 'Connect with other merchants and share experiences'
        },
        {
          title: 'Blog',
          description: 'Articles and news about e-commerce'
        },
        {
          title: 'Quick Start Guide',
          description: 'Launch your store in simple steps'
        },
        {
          title: 'Video Library',
          description: 'Visual tutorials for all features'
        },
        {
          title: 'Tools & Templates',
          description: 'Free resources for your store success'
        }
      ],
      support: 'Help & Support'
    },
    hero: {
      description: 'Ecommaps is a comprehensive e-commerce solution designed to empower merchants and entrepreneurs to launch and manage their online stores efficiently. It features a simplified user interface that enables easy creation and customization of online stores with multiple options to meet different brand needs. Ecommaps integrates various payment solutions with advanced marketing and analytical tools to ensure sales performance and enhance customer experience.',
      cta: 'Start Your Store Now - Free',
      badge: 'New Version 2.0 is Live'
    },
    features: {
      design: {
        title: 'Professional Store Design',
        description: 'Design your store easily and represent what you love'
      },
      marketing: {
        title: 'Marketing Tools',
        description: 'Boost your sales with multiple marketing solutions'
      },
      marketplace: {
        title: 'Smart Campaign Market',
        description: 'One market connecting sellers with customers'
      },
      affiliate: {
        title: 'Affiliate Marketing',
        description: 'Increase your sales through affiliate marketing'
      },
      network: {
        title: 'E-commerce Network',
        description: 'Advertise your product with top influencers in your sector'
      },
      payments: {
        title: 'Payments',
        description: 'Integrated financial management and flexible payment methods'
      },
      inventory: {
        title: 'Inventory Management',
        description: 'Comprehensive inventory management and logistics services'
      },
      partners: {
        title: 'Partners',
        description: 'Instant connection to professional logistics partners'
      }
    },
    howItWorks: {
      title: 'How to Start with',
      subtitle: 'Three simple steps to launch your online store',
      step1: {
        title: 'Create Your Store',
        description: 'Register your account and create your online store in minutes'
      },
      step2: {
        title: 'Add Your Products',
        description: 'Upload product images and add descriptions and prices easily'
      },
      step3: {
        title: 'Start Selling',
        description: 'Start receiving orders and growing your sales'
      }
    },
    advancedFeatures: {
      title: 'Advanced Features for Your Store Success',
      customization: {
        title: 'Full Store Customization',
        description: 'Customize your store completely to reflect your brand identity with professional templates and easy-to-use design tools'
      },
      analytics: {
        title: 'Smart Analytics',
        description: 'Get deep insights into your store performance with advanced analytics dashboard and detailed reports'
      },
      mobile: {
        title: 'Integrated Mobile App',
        description: 'Manage your store from anywhere with the integrated mobile app synced with the control panel'
      },
      seo: {
        title: 'Optimized Search Engine',
        description: 'Get better ranking in search results with advanced SEO tools built into the platform'
      },
      multiChannel: {
        title: 'Multi-Channel Selling',
        description: 'Connect your store with social media platforms and other online marketplaces'
      },
      automation: {
        title: 'Smart Automation',
        description: 'Save time with smart automation tools for managing orders, inventory, and shipping'
      }
    },
    trustedBy: {
      title: 'Trusted by Industry Leaders'
    },
    productShowcase: {
      title: 'One Platform, Infinite Possibilities',
      subtitle: 'Seamlessly switch between designing, managing, and analyzing for faster growth.',
      tabs: {
        builder: 'Visual Builder',
        dashboard: 'Dashboard',
        analytics: 'Advanced Analytics'
      },
      cards: {
        builder: {
          title: 'Advanced Visual Builder',
          description: 'Control every pixel with advanced drag & drop tools. No coding expertise required.',
          features: [
            'Drag & Drop Interface',
            'Instant Live Preview',
            '100+ Professional Templates'
          ]
        },
        dashboard: {
          title: 'Comprehensive Management',
          description: 'Track orders, inventory, and customers from one central place with ease.',
          features: [
            'Real-time Order Tracking',
            'Smart Inventory Management',
            'Customer Database'
          ]
        },
        analytics: {
          title: 'Precise Analytics',
          description: 'Make informed decisions based on accurate data about your store performance.',
          features: [
            'Daily Sales Reports',
            'Visitor Behavior Analysis',
            'Growth Projections'
          ]
        }
      }
    },
    stats: {
      title: 'Our Numbers Speak',
      merchants: {
        number: '5000+',
        label: 'Active Merchants'
      },
      orders: {
        number: '100,000+',
        label: 'Monthly Orders'
      },
      revenue: {
        number: '50M+',
        label: 'DZD in Sales'
      },
      satisfaction: {
        number: '98%',
        label: 'Customer Satisfaction'
      }
    },
    pricing: {
      title: 'Flexible Plans for Your Needs',
      subtitle: 'Choose the right plan for your business size',
      heroTitle: 'Pricing & Features',
      heroSubtitle: 'Choose the perfect plan to start or grow your e-commerce business',
      monthly: 'Monthly',
      yearly: 'Yearly',
      save20: 'Save 20%',
      starter: {
        name: 'Starter',
        price: 'Free',
        description: 'Perfect for getting started',
        features: [
          'Up to 50 products',
          'Free subdomain',
          'Basic support',
          'Basic reports',
          '3% commission'
        ]
      },
      pro: {
        name: 'Professional',
        price: '2,500 DZD/month',
        description: 'Most popular',
        features: [
          'Unlimited products',
          'Free custom domain',
          'Advanced 24/7 support',
          'Advanced analytics',
          '1.5% commission',
          'Mobile app'
        ],
        popular: true
      },
      enterprise: {
        name: 'Enterprise',
        price: 'Custom',
        description: 'For large businesses',
        features: [
          'All Pro features',
          'Dedicated account manager',
          'Custom integration',
          'Team training',
          'No commission',
          'Custom solutions'
        ]
      },
      comparison: {
        title: 'Compare Plans',
        subtitle: 'Choose the plan that suits your needs',
        features: {
          products: 'Number of Products',
          domain: 'Custom Domain',
          support: 'Support',
          analytics: 'Analytics',
          commission: 'Commission Rate',
          mobileApp: 'Mobile App',
          storage: 'Storage Space',
          bandwidth: 'Bandwidth',
          ssl: 'SSL Certificate',
          seo: 'SEO Tools',
          marketing: 'Marketing Tools',
          multiLanguage: 'Multi-language Support',
          inventory: 'Inventory Management',
          shipping: 'Shipping Integration',
          payments: 'Payment Methods',
          reports: 'Advanced Reports',
          api: 'API Access',
          customization: 'Full Customization'
        },
        values: {
          free: {
            products: 'Up to 50',
            domain: 'Subdomain',
            support: 'Email',
            analytics: 'Basic',
            commission: '3%',
            mobileApp: false,
            storage: '1 GB',
            bandwidth: '10 GB/month',
            ssl: true,
            seo: 'Basic',
            marketing: 'Limited',
            multiLanguage: true,
            inventory: 'Basic',
            shipping: 'Limited',
            payments: '2 methods',
            reports: 'Basic',
            api: false,
            customization: 'Limited'
          },
          pro: {
            products: 'Unlimited',
            domain: 'Free',
            support: '24/7 Chat & Phone',
            analytics: 'Advanced',
            commission: '1.5%',
            mobileApp: true,
            storage: '20 GB',
            bandwidth: 'Unlimited',
            ssl: true,
            seo: 'Advanced',
            marketing: 'Full',
            multiLanguage: true,
            inventory: 'Advanced',
            shipping: 'Full',
            payments: 'Unlimited',
            reports: 'Advanced',
            api: true,
            customization: 'Full'
          }
        }
      },
      faq: {
        title: 'Frequently Asked Questions',
        subtitle: 'Everything you need to know about our plans',
        questions: [
          {
            q: 'Can I change my plan later?',
            a: 'Yes, you can upgrade or downgrade at any time. The price difference will be calculated proportionally.'
          },
          {
            q: 'What payment methods are available?',
            a: 'We accept credit cards, CCP, Baridi Mob, and direct bank transfer.'
          },
          {
            q: 'Are there additional fees on sales?',
            a: 'The Free plan includes 3% commission, Professional 1.5%, and Enterprise has no commission.'
          },
          {
            q: 'Can I cancel my subscription anytime?',
            a: 'Yes, you can cancel anytime without additional fees. You will retain access until the end of your billing period.'
          },
          {
            q: 'Is training included in the plan?',
            a: 'All plans include video tutorials and educational articles. Enterprise plan includes live training for your team.'
          },
          {
            q: 'How long is the free subscription?',
            a: 'The Free plan requires no credit card and you can use it with no time limit. Upgrade available anytime.'
          }
        ]
      },
      cta: 'Start Now',
      ctaSecondary: 'Contact Sales',
      perMonth: 'per month',
      popularBadge: 'Most Popular',
      whyChoose: {
        title: 'Why Choose eCommaps?',
        subtitle: 'Everything you need for your online store success in one place',
        reasons: [
          {
            title: 'Easy to Use',
            description: 'Simple interface that requires no technical expertise'
          },
          {
            title: 'Local Support',
            description: 'Arabic-speaking support team available 24/7'
          },
          {
            title: 'Algerian Payment Methods',
            description: 'Integration with CCP, Baridi Mob and all local methods'
          },
          {
            title: 'Local Shipping',
            description: 'Partnerships with best shipping companies in Algeria'
          },
          {
            title: 'Continuous Updates',
            description: 'New features and regular improvements for free'
          },
          {
            title: 'High Security',
            description: 'Advanced protection for your data and customer data'
          }
        ]
      },
      finalCta: {
        title: 'Ready to Get Started?',
        subtitle: 'Join thousands of merchants who trust eCommaps to manage their online stores',
        button: 'Start Free Now'
      }
    },
    testimonials: {
      title: 'What Our Customers Say',
      subtitle: 'Thousands of merchants trust Ecommaps.com',
      reviews: [
        {
          name: 'Ahmed Ben Ali',
          role: 'E-commerce Store Owner',
          content: 'Ecommaps changed my life! I was able to launch my store in less than an hour and now I sell my products all over Algeria. The platform is very easy and the support team is amazing.',
          rating: 5
        },
        {
          name: 'Fatima Zahra',
          role: 'Fashion Designer',
          content: 'The best e-commerce platform in Algeria! The marketing tools helped me double my sales in just two months.',
          rating: 5
        },
        {
          name: 'Mohamed Amine',
          role: 'Wholesale Merchant',
          content: 'Integration with payment and shipping systems saved me a lot of time. Now I focus on developing my products and the platform takes care of the rest.',
          rating: 5
        }
      ]
    },
    cta: {
      title: 'Start Your E-commerce Journey Today',
      subtitle: 'Join hundreds of merchants who trust ecommaps.com to manage their online stores',
      primaryButton: 'Start Your Free Trial',
      secondaryButton: 'Contact Us'
    },
    footer: {
      description: 'The leading e-commerce platform in Algeria supporting merchants and entrepreneurs',
      quickLinks: 'Quick Links',
      support: 'Support',
      contact: 'Contact Us',
      helpCenter: 'Help Center',
      faq: 'FAQ',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
      aboutUs: 'About Us',
      blog: 'Blog',
      copyright: 'All Rights Reserved | Part of LaboBank Holding Group'
    },
    verifyEmail: {
      title: 'Enter Verification Code',
      sentTo: 'A verification code has been sent to your email',
      enterCode: 'Enter the 6-digit code',
      resendCode: 'Resend Code',
      verify: 'Verify Now',
      timer: 'Resend available in',
      seconds: 'seconds',
      success: 'Verified successfully!',
      redirecting: 'Redirecting to dashboard...',
      error: 'Invalid code, please try again',
      codeResent: 'Code resent successfully',
      backToLogin: 'Back to Login',
      verifying: 'Verifying...'
    },
    verifyLogin: {
      title: 'Login Verification',
      sentTo: 'A verification code has been sent to your email',
      enterCode: 'Enter the 6-digit code to continue',
      resendCode: 'Resend Code',
      verify: 'Sign In',
      timer: 'Resend available in',
      seconds: 'seconds',
      success: 'Verified successfully!',
      redirecting: 'Redirecting to dashboard...',
      error: 'Invalid code, please try again',
      codeResent: 'Code resent successfully',
      backToLogin: 'Back to Login',
      verifying: 'Verifying...',
      securityMessage: 'We protect your account with two-step verification'
    },
    dashboard: {
      title: 'Dashboard',
      welcome: 'Welcome',
      subtitle: 'Manage your stores and track your sales from one place',
      merchant: 'Merchant',
      user: 'User',
      profile: {
        merchantAccount: 'Merchant Account',
        manageProfile: 'Manage Profile',
        settings: 'Settings',
        editSettings: 'Edit Settings',
        logout: 'Logout'
      },
      stats: {
        stores: 'Stores',
        orders: 'Orders',
        products: 'Products',
        revenue: 'Revenue'
      },
      stores: {
        title: 'Your Stores',
        createNew: 'Create New Store',
        noStores: 'No stores yet',
        createFirst: 'Create your first store and start selling!',
        viewStore: 'View Store',
        manageStore: 'Manage Store',
        noDescription: 'No description',
        active: 'Active',
        inactive: 'Inactive'
      },
      settings: {
        title: 'Settings',
        personalSettings: 'Personal Settings',
        subtitle: 'Manage your account and preferences',
        backToDashboard: 'Back to Dashboard',
        profile: {
          title: 'Profile',
          fullName: 'Full Name',
          email: 'Email Address',
          emailNote: 'Email address cannot be changed',
          saveChanges: 'Save Changes',
          phone: 'Phone Number'
        },
        business: {
          title: 'Business Information',
          companyName: 'Company Name',
          phone: 'Phone Number',
          phoneDescription: 'Will be used for order notifications',
          rc: 'Trade Registry (RC)',
          nif: 'Tax ID (NIF)',
          nis: 'Statistical ID (NIS)',
          art: 'Article ID (ART)',
          saveInfo: 'Save Business Information'
        },
        exchangeRates: {
          title: 'Exchange Rates',
          subtitle: 'Manage and customize exchange rates for all your stores',
          baseCurrency: 'Base Currency',
          targetCurrency: 'Target Currency',
          rate: 'Exchange Rate',
          active: 'Status',
          autoUpdate: 'Automatic',
          manualEntry: 'Manual',
          addRate: 'Add Custom Rate',
          saveChanges: 'Save Changes',
          delete: 'Delete',
          dialogTitle: 'Add Custom Exchange Rate',
        },
        appearance: {
          title: 'Appearance',
          subtitle: 'Customize the look and feel of your dashboard',
          theme: 'Theme',
          light: 'Light',
          dark: 'Dark',
          system: 'System',
          themeDescription: 'Select the theme for the dashboard'
        },
        billing: {
          title: 'Billing',
          badge: 'Soon'
        },
        notifications: {
          title: 'Notifications',
          newOrders: 'New Order Notifications',
          newOrdersDesc: 'Receive notification when a new order arrives',
          productUpdates: 'Product Updates',
          productUpdatesDesc: 'Notifications about inventory and product updates',
          weeklyReports: 'Weekly Reports',
          weeklyReportsDesc: 'Receive weekly summary of sales and performance',
          marketing: 'Marketing Messages',
          marketingDesc: 'Tips and special offers'
        },
        security: {
          title: 'Security',
          changePassword: 'Change Password',
          newPassword: 'New Password',
          confirmPassword: 'Confirm New Password',
          updatePassword: 'Update Password',
          updating: 'Updating...',
          passwordNote: 'Note: You won\'t need to enter your current password - just type the new one',
          twoFactor: 'Two-Factor Authentication',
          twoFactorDesc: 'Add an extra layer of security to your account',
          twoFactorComing: 'Coming Soon - Enable Two-Factor Authentication'
        },
        currentInfo: {
          title: 'Current Information',
          fullName: 'Full Name',
          email: 'Email Address',
          phone: 'Phone Number',
          lastUpdate: 'Last Update',
          notSet: 'Not Set',
          notAvailable: 'Not Available'
        },
        quickLinks: {
          analytics: 'Analytics',
          settings: 'Settings',
          domains: 'Domains',
          marketing: 'Marketing'
        }
      },
      storeDashboard: {
        title: 'Store Management',
        overview: 'Overview',
        pages: 'Pages',
        products: 'Products',
        orders: 'Orders',
        analytics: 'Analytics',
        settings: 'Store Settings',
        viewStore: 'View Store',
        editPage: 'Edit Page',
        createPage: 'Create New Page',
        manageProducts: 'Manage Products',
        addProduct: 'Add Product',
        viewOrders: 'View Orders',
        storeSettings: 'Settings',
        storeName: 'Store Name',
        storeDescription: 'Store Description',
        storeLogo: 'Store Logo',
        contactInfo: 'Contact Information',
        socialLinks: 'Social Media Links',
        saveSettings: 'Save Settings',
        noPages: 'No pages yet',
        createFirstPage: 'Create your first page using the drag-and-drop editor',
        delete: 'Delete',
        edit: 'Edit',
        startSelling: 'Start Selling',
        shareStore: 'Share your store link and start receiving orders',
        pagesSection: {
          title: 'Store Pages',
          subtitle: 'Create and edit your store pages using the drag-and-drop editor',
          newPage: 'New Page',
          tableHeaders: {
            title: 'Title',
            slug: 'URL',
            status: 'Status',
            lastUpdate: 'Last Update',
            actions: 'Actions'
          },
          published: 'Published',
          draft: 'Draft'
        },
        quickStart: {
          title: '🚀 Quick Start Guide',
          steps: [
            { title: 'Create Homepage', desc: 'Use the visual editor to design your store interface' },
            { title: 'Add Your Products', desc: 'Add your products with images and prices' },
            { title: 'Start Selling', desc: 'Share your store link and start receiving orders' }
          ]
        }
      },
      editor: {
        title: 'Page Editor',
        save: 'Save',
        publish: 'Publish',
        preview: 'Preview',
        saved: 'Saved',
        publishing: 'Publishing...',
        published: 'Published',
        viewLive: 'View Store',
        backToPages: 'Back to Pages',
        components: 'Components',
        addComponent: 'Add Component',
        editComponent: 'Edit Component',
        deleteComponent: 'Delete Component',
        aiGenerate: 'AI Generate',
        generating: 'Generating...'
      },
      themes: {
        title: 'Themes',
        subtitle: 'Choose your store design',
        browse: 'Browse Themes',
        current: 'Current Theme',
        preview: 'Preview',
        apply: 'Apply',
        customize: 'Customize',
        colors: 'Colors',
        fonts: 'Fonts',
        layout: 'Layout',
        advanced: 'Advanced',
        saveChanges: 'Save Changes',
        resetToDefault: 'Reset to Default'
      },
      marketing: {
        title: 'Marketing',
        subtitle: 'Tools to grow your store',
        campaigns: 'Campaigns',
        coupons: 'Coupons & Discounts',
        emailMarketing: 'Email Marketing',
        seo: 'SEO Optimization',
        socialMedia: 'Social Media',
        createCampaign: 'Create New Campaign',
        createCoupon: 'Create Coupon',
        viewReports: 'View Reports',
        analytics: 'Marketing Analytics'
      },
      sidebar: {
        dashboard: 'Dashboard',
        products: 'Products',
        orders: 'Orders',
        analytics: 'Analytics',
        marketing: 'Marketing',
        settings: 'Settings',
        pageEditor: 'Page Editor',
        storeManagement: 'Store Management',
        backToDashboard: 'Back to Dashboard'
      }
    },
    createStore: {
      hero: {
        badge: 'Create Your Online Store in Minutes',
        title: 'Create Your Online Store the Easiest Way',
        subtitle: 'No coding, no complexity - your professional store ready in minutes',
        cta: 'Start Free Now',
        learnMore: 'Learn More',
        stats: [
          { number: '5 Minutes', label: 'To Create Store' },
          { number: 'No Coding', label: 'Easy & Simple' },
          { number: '5000+', label: 'Active Merchants' },
          { number: '24/7', label: 'Support' }
        ]
      },
      multilingual: {
        title: 'Speak Your Customers\' Language',
        description: 'Your store is available in three languages (Arabic, English, French) to reach the largest audience in Algeria and the Arab world',
        features: [
          'Automatic multilingual interface',
          'Professional translation of all store elements',
          'Smooth language switching',
          'Full Arabic (RTL) support'
        ]
      },
      existingStore: {
        title: 'Already Have a Store?',
        description: 'Migrate your existing store to eCommaps easily and benefit from all advanced features',
        benefit1: 'Smooth transfer of all your data and products',
        benefit2: 'Keep your customers and previous orders',
        benefit3: 'Free technical support for migration',
        cta: 'Start Migration Now'
      },
      fullControl: {
        title: 'Control Everything',
        subtitle: 'Manage your entire store from one simple yet powerful dashboard',
        features: [
          {
            title: 'Comprehensive Dashboard',
            description: 'Manage all aspects of your store from one place with an easy-to-use interface'
          },
          {
            title: 'Full Design Customization',
            description: 'Make your store unique with professional templates and advanced customization tools'
          },
          {
            title: 'Reports & Statistics',
            description: 'Track your store performance with detailed reports and smart analytics'
          }
        ]
      },
      customerForever: {
        title: 'Your Customer Forever',
        description: 'Build long-term relationships with your customers through smart customer management and loyalty tools',
        features: [
          'Loyalty system and reward programs',
          'Smart notifications for customer return',
          'Advanced customer database',
          'Personalized marketing for each customer'
        ],
        stat1: 'Customer Return Rate',
        stat2: 'Customer Rating',
        stat3: 'Increase in Repeat Sales',
        stat4: 'In Customer Satisfaction'
      },
      featuresGrid: {
        title: 'Everything You Need in One Place',
        subtitle: 'Integrated features to launch and manage a successful online store',
        items: [
          {
            icon: 'clock',
            title: 'Create in Minutes',
            description: 'Your store ready in just 5 minutes'
          },
          {
            icon: 'code',
            title: 'No Coding',
            description: 'No technical experience needed'
          },
          {
            icon: 'smartphone',
            title: 'Mobile Friendly',
            description: 'Your store works perfectly on all devices'
          },
          {
            icon: 'palette',
            title: 'Professional Templates',
            description: 'Hundreds of ready-to-use templates'
          },
          {
            icon: 'shield',
            title: 'High Security',
            description: 'Advanced protection for your data and customers'
          },
          {
            icon: 'creditCard',
            title: 'Online Payment',
            description: 'Integration with all payment gateways'
          },
          {
            icon: 'truck',
            title: 'Smart Shipping',
            description: 'Automatic integration with shipping companies'
          },
          {
            icon: 'barChart',
            title: 'Advanced Analytics',
            description: 'Deep understanding of your store performance'
          }
        ]
      },
      availableService: {
        title: 'Service Available Around the Clock',
        description: 'Professional support team ready to help you anytime',
        services: [
          {
            title: '24/7 Technical Support',
            description: 'Our team is always available to answer your questions and help you'
          },
          {
            title: 'Comprehensive Learning Center',
            description: 'Rich library of illustrated tutorials and lessons'
          },
          {
            title: 'Active Community',
            description: 'Join thousands of merchants and exchange experiences'
          }
        ],
        supportTitle: 'We\'re Here to Help',
        supportDescription: 'Contact us via chat, phone, or email',
        contactButton: 'Contact Us Now'
      },
      professionalManagement: {
        title: 'Master Your Store Management',
        subtitle: 'Professional tools to efficiently manage all aspects of your store',
        tools: [
          {
            title: 'Product Management',
            description: 'Add and edit your products easily with advanced inventory management',
            features: [
              'Add unlimited products',
              'Smart categories and tags',
              'Automatic inventory management',
              'Bulk import'
            ]
          },
          {
            title: 'Order Management',
            description: 'Track and process orders with high efficiency',
            features: [
              'Advanced order system',
              'Instant notifications',
              'Shipment tracking',
              'Return management'
            ]
          },
          {
            title: 'Customer Management',
            description: 'Build strong relationships with your customers',
            features: [
              'Comprehensive database',
              'Complete order history',
              'Loyalty programs',
              'Customer segmentation'
            ]
          }
        ]
      },
      successSteps: {
        title: 'Steps to Success',
        subtitle: 'Follow these simple steps to launch your successful store',
        steps: [
          {
            title: 'Register Account',
            description: 'Create free account in seconds'
          },
          {
            title: 'Design Store',
            description: 'Choose a template and customize it'
          },
          {
            title: 'Add Products',
            description: 'Upload products and set prices'
          },
          {
            title: 'Start Selling',
            description: 'Launch store and receive orders'
          }
        ]
      },
      customerData: {
        title: 'Collect Customer Data Smartly',
        description: 'Deep understanding of customer behavior helps you improve sales and shopping experience',
        benefits: [
          'Comprehensive customer behavior analysis',
          'Track complete purchase journey',
          'Detailed interest reports',
          'Smart product recommendations'
        ],
        metric1: 'Active Customers',
        metric2: 'Customer Growth',
        metric3: 'Satisfaction Rate'
      },
      successTools: {
        title: 'Success Tools at Your Fingertips',
        subtitle: 'Everything you need to grow your store and increase sales',
        tools: [
          {
            icon: 'zap',
            title: 'Smart Marketing',
            description: 'Advanced marketing tools to attract more customers and increase sales'
          },
          {
            icon: 'target',
            title: 'Targeted Campaigns',
            description: 'Create precise marketing campaigns that reach the right audience at the right time'
          },
          {
            icon: 'trendingUp',
            title: 'SEO Optimization',
            description: 'Advanced SEO tools for better visibility in search results'
          },
          {
            icon: 'shield',
            title: 'Guaranteed Security',
            description: 'Multi-layered protection for your store and customer data'
          },
          {
            icon: 'users',
            title: 'Team Management',
            description: 'Add team members and set access permissions easily'
          },
          {
            icon: 'rocket',
            title: 'Continuous Growth',
            description: 'Ongoing tools and updates to help you grow'
          }
        ]
      },
      pricingPreview: {
        title: 'Flexible Plans for All Needs',
        subtitle: 'Start free and upgrade as your store grows',
        popularBadge: 'Most Popular',
        plans: [
          {
            name: 'Starter',
            price: 'Free',
            features: [
              'Up to 50 products',
              'Free subdomain',
              'Basic support',
              'Basic reports'
            ],
            cta: 'Start Free',
            popular: false
          },
          {
            name: 'Professional',
            price: '2,500 DZD/month',
            features: [
              'Unlimited products',
              'Free custom domain',
              '24/7 Support',
              'Advanced analytics',
              'Mobile app'
            ],
            cta: 'Try Now',
            popular: true
          },
          {
            name: 'Enterprise',
            price: 'Custom',
            features: [
              'All Pro features',
              'Dedicated account manager',
              'Custom integration',
              'No commission'
            ],
            cta: 'Contact Us',
            popular: false
          }
        ],
        viewAll: 'View All Plans'
      },
      finalCta: {
        title: 'Ready to Launch Your Store?',
        subtitle: 'Join thousands of merchants who chose eCommaps to build their successful online stores',
        primaryButton: 'Create Your Store Now',
        secondaryButton: 'Learn More'
      }
    },
    pos: {
      hero: {
        badge: 'Complete POS System',
        title: 'Transform Your Traditional Store into an Integrated Digital Experience',
        subtitle: 'Professional POS system integrated with your online store - Unified inventory and sales management',
        primaryButton: 'Start Your Free Trial',
        secondaryButton: 'Watch Demo',
        stats: [
          { value: '3', label: 'Minutes to Install' },
          { value: '100%', label: 'Auto Sync' },
          { value: '24/7', label: 'Technical Support' },
          { value: '0 DA', label: 'Setup Fees' }
        ]
      },
      whyNeed: {
        title: 'Why Do You Need POS from eCommaps?',
        subtitle: 'An integrated system combining e-commerce power with traditional POS ease',
        features: [
          {
            title: 'Instant Sync with Online Store',
            description: 'Every in-store sale reflects directly on your online inventory'
          },
          {
            title: 'Unified Inventory Management',
            description: 'No more errors - one inventory synced across all points of sale'
          },
          {
            title: 'Comprehensive Detailed Reports',
            description: 'Accurate analytics for your in-store and online sales from one dashboard'
          },
          {
            title: 'Multiple Payment Methods Support',
            description: 'Cash, cards, digital wallet - everything in one place'
          }
        ]
      },
      features: {
        title: 'POS System Features',
        subtitle: 'Everything you need to manage your traditional store professionally',
        items: [
          {
            title: 'Easy-to-Use Interface',
            description: 'Simple and fast design that your staff can master in minutes'
          },
          {
            title: 'Professional Invoice Printing',
            description: 'Custom invoices with your logo and business details'
          },
          {
            title: 'Customer Management',
            description: 'Save your customer data, loyalty programs, and special discounts'
          },
          {
            title: 'Barcode Reader',
            description: 'Full support for barcode readers to scan products quickly'
          },
          {
            title: 'Daily and Monthly Reports',
            description: 'Detailed reports on sales, profits, and inventory'
          },
          {
            title: 'Offline Mode',
            description: 'Continue selling without internet - auto sync when back online'
          }
        ]
      },
      howToUse: {
        title: 'How to Start Using the POS System?',
        subtitle: 'Four simple steps to activate your point of sale',
        steps: [
          {
            title: 'Download the App',
            description: 'Available on Web, Windows, and Android'
          },
          {
            title: 'Link Your Account',
            description: 'Login with your online store account'
          },
          {
            title: 'Configure Settings',
            description: 'Choose printer, payment method, and tax settings'
          },
          {
            title: 'Start Selling',
            description: 'Everything is ready - start receiving customers'
          }
        ]
      },
      storeTypes: {
        title: 'Suitable for All Store Types',
        subtitle: 'A flexible system that adapts to your business needs',
        types: [
          {
            title: 'Clothing Stores',
            description: 'Manage sizes, colors, and styles easily'
          },
          {
            title: 'Electronics Stores',
            description: 'Track serial numbers and warranties'
          },
          {
            title: 'Cafes and Restaurants',
            description: 'Food menus and order customization options'
          },
          {
            title: 'Pharmacies',
            description: 'Track expiration dates and prescriptions'
          },
          {
            title: 'Gift Shops',
            description: 'Wrapping and card options'
          },
          {
            title: 'Any Other Type',
            description: 'Flexible system customizable to your needs'
          }
        ]
      },
      integration: {
        title: 'Seamless Integration with Your Online Store',
        subtitle: 'One system to manage all sales channels',
        benefits: [
          'Unified inventory updates automatically',
          'Comprehensive reports for all channels',
          'Centralized customer data',
          'Unified payment methods',
          'Integrated marketing campaigns',
          'Unified loyalty programs'
        ]
      },
      pricing: {
        title: 'POS System Pricing Plans',
        subtitle: 'Choose the plan that fits your business size',
        plans: [
          {
            name: 'Basic Plan',
            price: 'Free',
            period: 'monthly',
            description: 'Perfect for small stores',
            features: [
              'One point of sale',
              'Unlimited products',
              'Sync with online store',
              'Basic reports',
              'Technical support'
            ]
          },
          {
            name: 'Advanced Plan',
            price: '4,999',
            period: 'monthly',
            description: 'For medium stores',
            popular: true,
            features: [
              'Up to 5 points of sale',
              'All Basic Plan features',
              'Advanced reports',
              'Staff management',
              'Loyalty programs',
              'Barcode support'
            ]
          },
          {
            name: 'Professional Plan',
            price: 'Custom',
            period: '',
            description: 'For large stores',
            features: [
              'Unlimited points of sale',
              'All Advanced features',
              'Custom API',
              'Dedicated account manager',
              'Team training',
              'VIP support'
            ]
          }
        ]
      },
      testimonials: {
        title: 'What Our Customers Say',
        items: [
          {
            name: 'Ahmed Ben Mohamed',
            role: 'Clothing Store Owner',
            text: 'The POS system from eCommaps completely changed my way of working. Now I control everything from one place.'
          },
          {
            name: 'Fatima Zahra',
            role: 'Electronics Store Owner',
            text: 'Instant sync with the online store saved me a lot of time and errors.'
          },
          {
            name: 'Khaled Al Arabi',
            role: 'Cafe Owner',
            text: 'Easy to use and fast. My staff learned it in less than an hour.'
          }
        ]
      },
      hardware: {
        title: 'Supported Devices',
        subtitle: 'Works with most POS devices available in the market',
        devices: [
          {
            title: 'Receipt Printers',
            description: 'Support for all 80mm and 58mm thermal printers'
          },
          {
            title: 'Barcode Readers',
            description: 'Compatible with all USB and Bluetooth readers'
          },
          {
            title: 'Cash Drawers',
            description: 'Opens automatically after each cash sale'
          },
          {
            title: 'Payment Devices',
            description: 'Integrated with popular electronic payment devices'
          }
        ]
      },
      finalCta: {
        title: 'Ready to Transform Your Store into a Digital Experience?',
        subtitle: 'Start your free trial today, no credit card required',
        primaryButton: 'Start Your Free Trial',
        secondaryButton: 'Talk to an Expert'
      }
    }
  },
  fr: {
    nav: {
      features: 'Fonctionnalités',
      howItWorks: 'Comment ça marche',
      pricing: 'Tarifs',
      testimonials: 'Témoignages',
      startNow: 'Commencer',
      featuresMenu: [
        {
          title: 'Boutique en Ligne',
          description: 'Transformez votre boutique en succès en ligne'
        },
        {
          title: 'PDV (Point de Vente)',
          description: 'Système de caisse professionnel intégré à votre boutique'
        },
        {
          title: 'Thèmes',
          description: 'Concevez votre boutique à votre façon'
        },
        {
          title: 'Point de Vente (PDV)',
          description: 'Gérez vos opérations depuis un seul panneau'
        },
        {
          title: 'Paiements',
          description: 'Recevez et gérez vos paiements facilement'
        },
        {
          title: 'Expédition',
          description: 'Solutions d\'expédition intelligentes pour votre entreprise'
        },
        {
          title: 'Financement',
          description: 'Financement instantané pour développer votre entreprise'
        },
        {
          title: 'Outils Marketing',
          description: 'Transformez votre boutique en aimant à clients'
        },
        {
          title: 'Gestion des Stocks',
          description: 'Gérez votre inventaire efficacement et facilement'
        }
      ],
      howItWorksMenu: [
        {
          title: 'Créer un Compte',
          description: 'Inscrivez-vous gratuitement en quelques minutes'
        },
        {
          title: 'Choisir le Plan',
          description: 'Sélectionnez le plan qui correspond à vos besoins'
        },
        {
          title: 'Concevoir la Boutique',
          description: 'Personnalisez le design de votre boutique facilement'
        },
        {
          title: 'Ajouter des Produits',
          description: 'Ajoutez vos produits rapidement et facilement'
        },
        {
          title: 'Configurer Paiement & Expédition',
          description: 'Activez les méthodes de paiement et d\'expédition appropriées'
        },
        {
          title: 'Lancer la Boutique',
          description: 'Lancez votre boutique aux clients et commencez à vendre'
        },
        {
          title: 'Gérer les Commandes',
          description: 'Suivez et gérez vos commandes efficacement'
        },
        {
          title: 'Suivre les Performances',
          description: 'Surveillez vos ventes et analysez vos données'
        },
        {
          title: 'Croître & Développer',
          description: 'Développez votre entreprise avec nos outils avancés'
        }
      ],
      supportMenu: [
        {
          title: 'Centre d\'Aide',
          description: 'Guide complet pour utiliser la plateforme eCommaps'
        },
        {
          title: 'Contacter le Support',
          description: 'Notre équipe est prête à répondre à vos questions'
        },
        {
          title: 'FAQ',
          description: 'Réponses rapides aux questions fréquentes'
        },
        {
          title: 'Académie eCommaps',
          description: 'Apprenez les stratégies du commerce électronique'
        },
        {
          title: 'Communauté des Marchands',
          description: 'Connectez-vous avec d\'autres marchands'
        },
        {
          title: 'Blog',
          description: 'Articles et actualités sur le e-commerce'
        },
        {
          title: 'Guide de Démarrage Rapide',
          description: 'Lancez votre boutique en étapes simples'
        },
        {
          title: 'Bibliothèque Vidéo',
          description: 'Tutoriels visuels pour toutes les fonctionnalités'
        },
        {
          title: 'Outils & Modèles',
          description: 'Ressources gratuites pour votre succès'
        }
      ],
      support: 'Aide & Support'
    },
    hero: {
      description: 'Ecommaps est une solution e-commerce complète conçue pour permettre aux commerçants et entrepreneurs de lancer et gérer leurs boutiques en ligne efficacement. Il propose une interface utilisateur simplifiée qui permet de créer et personnaliser facilement des boutiques en ligne avec de multiples options pour répondre aux besoins de différentes marques. Ecommaps intègre diverses solutions de paiement avec des outils marketing et analytiques avancés pour assurer la performance des ventes et améliorer l\'expérience client.',
      cta: 'Lancez votre boutique maintenant - Gratuit',
      badge: 'Nouvelle Version 2.0 est En Ligne'
    },
    trustedBy: {
      title: 'Reconnu par les Leaders de l\'Industrie'
    },
    productShowcase: {
      title: 'Une Plateforme, Des Possibilités Infinies',
      subtitle: 'Passez sans effort de la conception à la gestion et à l\'analyse pour une croissance plus rapide.',
      tabs: {
        builder: 'Constructeur Visuel',
        dashboard: 'Tableau de Bord',
        analytics: 'Analyses Avancées'
      },
      cards: {
        builder: {
          title: 'Constructeur Visuel Avancé',
          description: 'Contrôlez chaque pixel avec des outils de glisser-déposer avancés. Aucune expertise en codage requise.',
          features: [
            'Interface Glisser-Déposer',
            'Aperçu en Direct Instantané',
            '100+ Modèles Professionnels'
          ]
        },
        dashboard: {
          title: 'Gestion Complète',
          description: 'Suivez vos commandes, stocks et clients depuis un endroit centralisé en toute simplicité.',
          features: [
            'Suivi des Commandes en Temps Réel',
            'Gestion Intelligente des Stocks',
            'Base de Données Clients'
          ]
        },
        analytics: {
          title: 'Analyses Précises',
          description: 'Prenez des décisions éclairées basées sur des données précises concernant la performance de votre boutique.',
          features: [
            'Rapports de Ventes Quotidiens',
            'Analyse du Comportement des Visiteurs',
            'Projections de Croissance'
          ]
        }
      }
    },
    features: {
      design: {
        title: 'Design Professionnel',
        description: 'Concevez votre boutique facilement et représentez ce que vous aimez'
      },
      marketing: {
        title: 'Outils Marketing',
        description: 'Boostez vos ventes avec plusieurs solutions marketing'
      },
      marketplace: {
        title: 'Marché Intelligent',
        description: 'Un marché connectant vendeurs et clients'
      },
      affiliate: {
        title: 'Marketing d\'Affiliation',
        description: 'Augmentez vos ventes via le marketing d\'affiliation'
      },
      network: {
        title: 'Réseau E-commerce',
        description: 'Annoncez votre produit avec les meilleurs influenceurs de votre secteur'
      },
      payments: {
        title: 'Paiements',
        description: 'Gestion financière intégrée et méthodes de paiement flexibles'
      },
      inventory: {
        title: 'Gestion des Stocks',
        description: 'Gestion complète des stocks et services logistiques'
      },
      partners: {
        title: 'Partenaires',
        description: 'Connexion instantanée aux partenaires logistiques professionnels'
      }
    },
    howItWorks: {
      title: 'Comment commencer avec',
      subtitle: 'Trois étapes simples pour lancer votre boutique en ligne',
      step1: {
        title: 'Créez votre boutique',
        description: 'Enregistrez votre compte et créez votre boutique en ligne en quelques minutes'
      },
      step2: {
        title: 'Ajoutez vos produits',
        description: 'Téléchargez des images de produits et ajoutez facilement des descriptions et des prix'
      },
      step3: {
        title: 'Commencez à vendre',
        description: 'Commencez à recevoir des commandes et à développer vos ventes'
      }
    },
    advancedFeatures: {
      title: 'Fonctionnalités Avancées pour le Succès de Votre Boutique',
      customization: {
        title: 'Personnalisation Complète',
        description: 'Personnalisez complètement votre boutique pour refléter l\'identité de votre marque avec des modèles professionnels et des outils de conception faciles à utiliser'
      },
      analytics: {
        title: 'Analyses Intelligentes',
        description: 'Obtenez des informations approfondies sur les performances de votre boutique avec un tableau de bord analytique avancé et des rapports détaillés'
      },
      mobile: {
        title: 'Application Mobile Intégrée',
        description: 'Gérez votre boutique de n\'importe où avec l\'application mobile intégrée synchronisée avec le panneau de contrôle'
      },
      seo: {
        title: 'Moteur de Recherche Optimisé',
        description: 'Obtenez un meilleur classement dans les résultats de recherche avec des outils SEO avancés intégrés à la plateforme'
      },
      multiChannel: {
        title: 'Vente Multi-Canaux',
        description: 'Connectez votre boutique avec les plateformes de médias sociaux et d\'autres marchés en ligne'
      },
      automation: {
        title: 'Automatisation Intelligente',
        description: 'Gagnez du temps avec des outils d\'automatisation intelligents pour gérer les commandes, les stocks et l\'expédition'
      }
    },
    stats: {
      title: 'Nos Chiffres Parlent',
      merchants: {
        number: '5000+',
        label: 'Marchands Actifs'
      },
      orders: {
        number: '100 000+',
        label: 'Commandes Mensuelles'
      },
      revenue: {
        number: '50M+',
        label: 'DZD de Ventes'
      },
      satisfaction: {
        number: '98%',
        label: 'Satisfaction Client'
      }
    },
    pricing: {
      title: 'Plans Flexibles pour Vos Besoins',
      subtitle: 'Choisissez le plan adapté à la taille de votre entreprise',
      heroTitle: 'Tarification & Fonctionnalités',
      heroSubtitle: 'Choisissez le plan parfait pour démarrer ou développer votre entreprise e-commerce',
      monthly: 'Mensuel',
      yearly: 'Annuel',
      save20: 'Économisez 20%',
      starter: {
        name: 'Débutant',
        price: 'Gratuit',
        description: 'Parfait pour commencer',
        features: [
          'Jusqu\'à 50 produits',
          'Sous-domaine gratuit',
          'Support de base',
          'Rapports de base',
          'Commission de 3%'
        ]
      },
      pro: {
        name: 'Professionnel',
        price: '2 500 DZD/mois',
        description: 'Le plus populaire',
        features: [
          'Produits illimités',
          'Domaine personnalisé gratuit',
          'Support avancé 24/7',
          'Analyses avancées',
          'Commission de 1,5%',
          'Application mobile'
        ],
        popular: true
      },
      enterprise: {
        name: 'Entreprise',
        price: 'Personnalisé',
        description: 'Pour les grandes entreprises',
        features: [
          'Toutes les fonctionnalités Pro',
          'Gestionnaire de compte dédié',
          'Intégration personnalisée',
          'Formation d\'équipe',
          'Sans commission',
          'Solutions personnalisées'
        ]
      },
      comparison: {
        title: 'Comparer les Plans',
        subtitle: 'Choisissez le plan qui correspond à vos besoins',
        features: {
          products: 'Nombre de Produits',
          domain: 'Domaine Personnalisé',
          support: 'Support',
          analytics: 'Analyses',
          commission: 'Taux de Commission',
          mobileApp: 'Application Mobile',
          storage: 'Espace de Stockage',
          bandwidth: 'Bande Passante',
          ssl: 'Certificat SSL',
          seo: 'Outils SEO',
          marketing: 'Outils Marketing',
          multiLanguage: 'Support Multilingue',
          inventory: 'Gestion des Stocks',
          shipping: 'Intégration Expédition',
          payments: 'Méthodes de Paiement',
          reports: 'Rapports Avancés',
          api: 'Accès API',
          customization: 'Personnalisation Complète'
        },
        values: {
          free: {
            products: 'Jusqu\'à 50',
            domain: 'Sous-domaine',
            support: 'Email',
            analytics: 'Base',
            commission: '3%',
            mobileApp: false,
            storage: '1 GB',
            bandwidth: '10 GB/mois',
            ssl: true,
            seo: 'Base',
            marketing: 'Limité',
            multiLanguage: true,
            inventory: 'Base',
            shipping: 'Limité',
            payments: '2 méthodes',
            reports: 'Base',
            api: false,
            customization: 'Limité'
          },
          pro: {
            products: 'Illimité',
            domain: 'Gratuit',
            support: '24/7 Chat & Téléphone',
            analytics: 'Avancé',
            commission: '1,5%',
            mobileApp: true,
            storage: '20 GB',
            bandwidth: 'Illimité',
            ssl: true,
            seo: 'Avancé',
            marketing: 'Complet',
            multiLanguage: true,
            inventory: 'Avancé',
            shipping: 'Complet',
            payments: 'Illimité',
            reports: 'Avancé',
            api: true,
            customization: 'Complet'
          }
        }
      },
      faq: {
        title: 'Questions Fréquemment Posées',
        subtitle: 'Tout ce que vous devez savoir sur nos plans',
        questions: [
          {
            q: 'Puis-je changer de plan plus tard?',
            a: 'Oui, vous pouvez passer à un plan supérieur ou inférieur à tout moment. La différence de prix sera calculée au prorata.'
          },
          {
            q: 'Quels modes de paiement sont disponibles?',
            a: 'Nous acceptons les cartes bancaires, CCP, Baridi Mob et le virement bancaire direct.'
          },
          {
            q: 'Y a-t-il des frais supplémentaires sur les ventes?',
            a: 'Le plan Gratuit inclut une commission de 3%, Professionnel 1,5%, et Entreprise n\'a pas de commission.'
          },
          {
            q: 'Puis-je annuler mon abonnement à tout moment?',
            a: 'Oui, vous pouvez annuler à tout moment sans frais supplémentaires. Vous conserverez l\'accès jusqu\'à la fin de votre période de facturation.'
          },
          {
            q: 'La formation est-elle incluse dans le plan?',
            a: 'Tous les plans incluent des tutoriels vidéo et des articles éducatifs. Le plan Entreprise inclut une formation en direct pour votre équipe.'
          },
          {
            q: 'Combien de temps dure l\'abonnement gratuit?',
            a: 'Le plan Gratuit ne nécessite pas de carte bancaire et vous pouvez l\'utiliser sans limite de temps. La mise à niveau est disponible à tout moment.'
          }
        ]
      },
      cta: 'Commencer',
      ctaSecondary: 'Contacter les Ventes',
      perMonth: 'par mois',
      popularBadge: 'Le Plus Populaire',
      whyChoose: {
        title: 'Pourquoi Choisir eCommaps?',
        subtitle: 'Tout ce dont vous avez besoin pour le succès de votre boutique en un seul endroit',
        reasons: [
          {
            title: 'Facile à Utiliser',
            description: 'Interface simple ne nécessitant aucune expertise technique'
          },
          {
            title: 'Support Local',
            description: 'Équipe de support arabophone disponible 24/7'
          },
          {
            title: 'Méthodes de Paiement Algériennes',
            description: 'Intégration avec CCP, Baridi Mob et toutes les méthodes locales'
          },
          {
            title: 'Expédition Locale',
            description: 'Partenariats avec les meilleures entreprises d\'expédition en Algérie'
          },
          {
            title: 'Mises à Jour Continues',
            description: 'Nouvelles fonctionnalités et améliorations régulières gratuites'
          },
          {
            title: 'Haute Sécurité',
            description: 'Protection avancée pour vos données et celles de vos clients'
          }
        ]
      },
      finalCta: {
        title: 'Prêt à Commencer?',
        subtitle: 'Rejoignez des milliers de marchands qui font confiance à eCommaps pour gérer leurs boutiques en ligne',
        button: 'Commencer Gratuitement'
      }
    },
    testimonials: {
      title: 'Ce Que Disent Nos Clients',
      subtitle: 'Des milliers de marchands font confiance à Ecommaps.com',
      reviews: [
        {
          name: 'Ahmed Ben Ali',
          role: 'Propriétaire de Boutique en Ligne',
          content: 'Ecommaps a changé ma vie! J\'ai pu lancer ma boutique en moins d\'une heure et maintenant je vends mes produits dans toute l\'Algérie. La plateforme est très facile et l\'équipe de support est incroyable.',
          rating: 5
        },
        {
          name: 'Fatima Zahra',
          role: 'Créatrice de Mode',
          content: 'La meilleure plateforme e-commerce en Algérie! Les outils marketing m\'ont aidé à doubler mes ventes en seulement deux mois.',
          rating: 5
        },
        {
          name: 'Mohamed Amine',
          role: 'Commerçant en Gros',
          content: 'L\'intégration avec les systèmes de paiement et d\'expédition m\'a fait gagner beaucoup de temps. Maintenant je me concentre sur le développement de mes produits et la plateforme s\'occupe du reste.',
          rating: 5
        }
      ]
    },
    cta: {
      title: 'Commencez Votre Voyage E-commerce Aujourd\'hui',
      subtitle: 'Rejoignez des centaines de marchands qui font confiance à ecommaps.com pour gérer leurs boutiques en ligne',
      primaryButton: 'Commencez Votre Essai Gratuit',
      secondaryButton: 'Contactez-nous'
    },
    footer: {
      description: 'La principale plateforme e-commerce en Algérie soutenant les marchands et entrepreneurs',
      quickLinks: 'Liens Rapides',
      support: 'Support',
      contact: 'Contactez-nous',
      helpCenter: 'Centre d\'aide',
      faq: 'FAQ',
      terms: 'Conditions d\'utilisation',
      privacy: 'Politique de confidentialité',
      aboutUs: 'À propos',
      blog: 'Blog',
      copyright: 'Tous droits réservés | Partie du groupe LaboBank Holding'
    },
    verifyEmail: {
      title: 'Entrez le Code de Vérification',
      sentTo: 'Un code de vérification a été envoyé à votre email',
      enterCode: 'Entrez le code à 6 chiffres',
      resendCode: 'Renvoyer le Code',
      verify: 'Vérifier Maintenant',
      timer: 'Renvoi disponible dans',
      seconds: 'secondes',
      success: 'Vérifié avec succès!',
      redirecting: 'Redirection vers le tableau de bord...',
      error: 'Code invalide, veuillez réessayer',
      codeResent: 'Code renvoyé avec succès',
      backToLogin: 'Retour à la connexion',
      verifying: 'Vérification en cours...'
    },
    verifyLogin: {
      title: 'Vérification de Connexion',
      sentTo: 'Un code de vérification a été envoyé à votre email',
      enterCode: 'Entrez le code à 6 chiffres pour continuer',
      resendCode: 'Renvoyer le Code',
      verify: 'Se Connecter',
      timer: 'Renvoi disponible dans',
      seconds: 'secondes',
      success: 'Vérifié avec succès!',
      redirecting: 'Redirection vers le tableau de bord...',
      error: 'Code invalide, veuillez réessayer',
      codeResent: 'Code renvoyé avec succès',
      backToLogin: 'Retour à la connexion',
      verifying: 'Vérification en cours...',
      securityMessage: 'Nous protégeons votre compte avec la vérification en deux étapes'
    },
    dashboard: {
      title: 'Tableau de Bord',
      welcome: 'Bienvenue',
      subtitle: 'Gérez vos magasins et suivez vos ventes depuis un seul endroit',
      merchant: 'Commerçant',
      user: 'Utilisateur',
      profile: {
        merchantAccount: 'Compte Commerçant',
        manageProfile: 'Gérer le Profil',
        settings: 'Paramètres',
        editSettings: 'Modifier les Paramètres',
        logout: 'Déconnexion'
      },
      stats: {
        stores: 'Magasins',
        orders: 'Commandes',
        products: 'Produits',
        revenue: 'Revenus'
      },
      stores: {
        title: 'Vos Magasins',
        createNew: 'Créer un Nouveau Magasin',
        noStores: 'Aucun magasin pour le moment',
        createFirst: 'Créez votre premier magasin et commencez à vendre!',
        viewStore: 'Voir le Magasin',
        manageStore: 'Gérer le Magasin',
        noDescription: 'Aucune description',
        active: 'Actif',
        inactive: 'Inactif'
      },
      settings: {
        title: 'Paramètres',
        personalSettings: 'Paramètres Personnels',
        subtitle: 'Gérez votre compte et vos préférences',
        backToDashboard: 'Retour au Tableau de Bord',
        profile: {
          title: 'Profil',
          fullName: 'Nom Complet',
          email: 'Adresse Email',
          emailNote: 'L\'adresse email ne peut pas être modifiée',
          saveChanges: 'Enregistrer les Modifications',
          phone: 'Numéro de Téléphone'
        },
        business: {
          title: 'Infos Pro',
          companyName: 'Nom de l\'Entreprise',
          phone: 'Numéro de Téléphone',
          phoneDescription: 'Sera utilisé pour les notifications de commandes',
          rc: 'Registre de Commerce (RC)',
          nif: 'Numéro d\'Identification Fiscale (NIF)',
          nis: 'Numéro d\'Identification Statistique (NIS)',
          art: 'Numéro d\'Article (ART)',
          saveInfo: 'Enregistrer les Informations Professionnelles'
        },
        exchangeRates: {
          title: 'Taux de Change',
          subtitle: 'Gérez et personnalisez les taux de change pour tous vos magasins',
          baseCurrency: 'Devise de Base',
          targetCurrency: 'Devise Cible',
          rate: 'Taux de Change',
          active: 'Statut',
          autoUpdate: 'Automatique',
          manualEntry: 'Manuel',
          addRate: 'Ajouter un Taux',
          saveChanges: 'Enregistrer',
          delete: 'Supprimer',
          dialogTitle: 'Ajouter un Taux de Change',
        },
        appearance: {
          title: 'Apparence',
          subtitle: 'Personnalisez l\'apparence de votre tableau de bord',
          theme: 'Thème',
          light: 'Clair',
          dark: 'Sombre',
          system: 'Système',
          themeDescription: 'Sélectionnez le thème du tableau de bord'
        },
        billing: {
          title: 'Facturation',
          badge: 'Bientôt'
        },
        notifications: {
          title: 'Notifications',
          newOrders: 'Notifications de Nouvelles Commandes',
          newOrdersDesc: 'Recevoir une notification lors d\'une nouvelle commande',
          productUpdates: 'Mises à Jour des Produits',
          productUpdatesDesc: 'Notifications sur les mises à jour d\'inventaire et de produits',
          weeklyReports: 'Rapports Hebdomadaires',
          weeklyReportsDesc: 'Recevoir un résumé hebdomadaire des ventes et performances',
          marketing: 'Messages Marketing',
          marketingDesc: 'Conseils et offres spéciales'
        },
        security: {
          title: 'Sécurité',
          changePassword: 'Changer le Mot de Passe',
          newPassword: 'Nouveau Mot de Passe',
          confirmPassword: 'Confirmer le Nouveau Mot de Passe',
          updatePassword: 'Mettre à Jour le Mot de Passe',
          updating: 'Mise à jour en cours...',
          passwordNote: 'Note: Vous n\'aurez pas besoin d\'entrer votre mot de passe actuel - tapez simplement le nouveau',
          twoFactor: 'Authentification à Deux Facteurs',
          twoFactorDesc: 'Ajoutez une couche de sécurité supplémentaire à votre compte',
          twoFactorComing: 'Bientôt Disponible - Activer l\'Authentification à Deux Facteurs'
        },
        currentInfo: {
          title: 'Informations Actuelles',
          fullName: 'Nom Complet',
          email: 'Adresse Email',
          phone: 'Numéro de Téléphone',
          lastUpdate: 'Dernière Mise à Jour',
          notSet: 'Non Défini',
          notAvailable: 'Non Disponible'
        },
        quickLinks: {
          analytics: 'Analytique',
          settings: 'Paramètres',
          domains: 'Domaines',
          marketing: 'Marketing'
        }
      },
      storeDashboard: {
        title: 'Gestion du Magasin',
        overview: 'Aperçu',
        pages: 'Pages',
        products: 'Produits',
        orders: 'Commandes',
        analytics: 'Analytique',
        settings: 'Paramètres du Magasin',
        viewStore: 'Voir le Magasin',
        editPage: 'Modifier la Page',
        createPage: 'Créer une Nouvelle Page',
        manageProducts: 'Gérer les Produits',
        addProduct: 'Ajouter un Produit',
        viewOrders: 'Voir les Commandes',
        storeSettings: 'Paramètres',
        storeName: 'Nom du Magasin',
        storeDescription: 'Description du Magasin',
        storeLogo: 'Logo du Magasin',
        contactInfo: 'Informations de Contact',
        socialLinks: 'Liens des Réseaux Sociaux',
        saveSettings: 'Enregistrer les Paramètres',
        noPages: 'Aucune page pour le moment',
        createFirstPage: 'Créez votre première page avec l\'éditeur glisser-déposer',
        delete: 'Supprimer',
        edit: 'Modifier',
        startSelling: 'Commencer à Vendre',
        shareStore: 'Partagez le lien de votre magasin et commencez à recevoir des commandes',
        pagesSection: {
          title: 'Pages du Magasin',
          subtitle: 'Créez et modifiez les pages de votre magasin avec l\'éditeur glisser-déposer',
          newPage: 'Nouvelle Page',
          tableHeaders: {
            title: 'Titre',
            slug: 'URL',
            status: 'Statut',
            lastUpdate: 'Dernière Mise à Jour',
            actions: 'Actions'
          },
          published: 'Publié',
          draft: 'Brouillon'
        },
        quickStart: {
          title: '🚀 Guide de Démarrage Rapide',
          steps: [
            { title: 'Créer la Page d\'Accueil', desc: 'Utilisez l\'éditeur visuel pour concevoir l\'interface de votre magasin' },
            { title: 'Ajoutez Vos Produits', desc: 'Ajoutez vos produits avec images et prix' },
            { title: 'Commencez à Vendre', desc: 'Partagez le lien de votre magasin et commencez à recevoir des commandes' }
          ]
        }
      },
      editor: {
        title: 'Éditeur de Pages',
        save: 'Enregistrer',
        publish: 'Publier',
        preview: 'Aperçu',
        saved: 'Enregistré',
        publishing: 'Publication en cours...',
        published: 'Publié',
        viewLive: 'Voir le Magasin',
        backToPages: 'Retour aux Pages',
        components: 'Composants',
        addComponent: 'Ajouter un Composant',
        editComponent: 'Modifier le Composant',
        deleteComponent: 'Supprimer le Composant',
        aiGenerate: 'Générer avec IA',
        generating: 'Génération en cours...'
      },
      themes: {
        title: 'Thèmes',
        subtitle: 'Choisissez le design de votre magasin',
        browse: 'Parcourir les Thèmes',
        current: 'Thème Actuel',
        preview: 'Aperçu',
        apply: 'Appliquer',
        customize: 'Personnaliser',
        colors: 'Couleurs',
        fonts: 'Polices',
        layout: 'Mise en Page',
        advanced: 'Avancé',
        saveChanges: 'Enregistrer les Modifications',
        resetToDefault: 'Réinitialiser par Défaut'
      },
      marketing: {
        title: 'Marketing',
        subtitle: 'Outils pour développer votre magasin',
        campaigns: 'Campagnes',
        coupons: 'Coupons et Remises',
        emailMarketing: 'Marketing par Email',
        seo: 'Optimisation SEO',
        socialMedia: 'Réseaux Sociaux',
        createCampaign: 'Créer une Nouvelle Campagne',
        createCoupon: 'Créer un Coupon',
        viewReports: 'Voir les Rapports',
        analytics: 'Analytique Marketing'
      },
      sidebar: {
        dashboard: 'Tableau de bord',
        products: 'Produits',
        orders: 'Commandes',
        analytics: 'Analytique',
        marketing: 'Marketing',
        settings: 'Paramètres',
        pageEditor: 'Éditeur de Pages',
        storeManagement: 'Gestion du Magasin',
        backToDashboard: 'Retour au Tableau de Bord'
      }
    },
    createStore: {
      hero: {
        badge: 'Créez Votre Boutique en Ligne en Minutes',
        title: 'Créez Votre Boutique en Ligne de la Manière la Plus Simple',
        subtitle: 'Sans codage, sans complexité - votre boutique professionnelle prête en quelques minutes',
        cta: 'Commencer Gratuitement',
        learnMore: 'En Savoir Plus',
        stats: [
          { number: '5 Minutes', label: 'Pour Créer' },
          { number: 'Sans Code', label: 'Facile & Simple' },
          { number: '5000+', label: 'Marchands Actifs' },
          { number: '24/7', label: 'Support' }
        ]
      },
      multilingual: {
        title: 'Parlez la Langue de Vos Clients',
        description: 'Votre boutique est disponible en trois langues (arabe, anglais, français) pour atteindre le plus large public en Algérie et dans le monde arabe',
        features: [
          'Interface multilingue automatique',
          'Traduction professionnelle de tous les éléments',
          'Changement de langue fluide',
          'Support complet de l\'arabe (RTL)'
        ]
      },
      existingStore: {
        title: 'Vous Avez Déjà une Boutique?',
        description: 'Migrez facilement votre boutique existante vers eCommaps et profitez de toutes les fonctionnalités avancées',
        benefit1: 'Transfert fluide de toutes vos données et produits',
        benefit2: 'Conservez vos clients et commandes précédentes',
        benefit3: 'Support technique gratuit pour la migration',
        cta: 'Commencer la Migration'
      },
      fullControl: {
        title: 'Contrôlez Tout',
        subtitle: 'Gérez l\'intégralité de votre boutique depuis un tableau de bord simple mais puissant',
        features: [
          {
            title: 'Tableau de Bord Complet',
            description: 'Gérez tous les aspects de votre boutique depuis un seul endroit avec une interface facile à utiliser'
          },
          {
            title: 'Personnalisation Complète',
            description: 'Rendez votre boutique unique avec des modèles professionnels et des outils de personnalisation avancés'
          },
          {
            title: 'Rapports & Statistiques',
            description: 'Suivez les performances de votre boutique avec des rapports détaillés et des analyses intelligentes'
          }
        ]
      },
      customerForever: {
        title: 'Votre Client pour Toujours',
        description: 'Construisez des relations durables avec vos clients grâce à des outils intelligents de gestion et de fidélisation',
        features: [
          'Système de fidélité et programmes de r��compenses',
          'Notifications intelligentes pour le retour des clients',
          'Base de données clients avancée',
          'Marketing personnalisé pour chaque client'
        ],
        stat1: 'Taux de Retour Client',
        stat2: 'Note Client',
        stat3: 'Augmentation des Ventes Répétées',
        stat4: 'En Satisfaction Client'
      },
      featuresGrid: {
        title: 'Tout ce Dont Vous Avez Besoin en Un Seul Endroit',
        subtitle: 'Fonctionnalités intégrées pour lancer et gérer une boutique en ligne réussie',
        items: [
          {
            icon: 'clock',
            title: 'Création en Minutes',
            description: 'Votre boutique prête en seulement 5 minutes'
          },
          {
            icon: 'code',
            title: 'Sans Codage',
            description: 'Aucune expérience technique requise'
          },
          {
            icon: 'smartphone',
            title: 'Compatible Mobile',
            description: 'Votre boutique fonctionne parfaitement sur tous les appareils'
          },
          {
            icon: 'palette',
            title: 'Modèles Professionnels',
            description: 'Des centaines de modèles prêts à l\'emploi'
          },
          {
            icon: 'shield',
            title: 'Haute Sécurité',
            description: 'Protection avancée pour vos données et clients'
          },
          {
            icon: 'creditCard',
            title: 'Paiement en Ligne',
            description: 'Intégration avec toutes les passerelles de paiement'
          },
          {
            icon: 'truck',
            title: 'Livraison Intelligente',
            description: 'Intégration automatique avec les sociétés de livraison'
          },
          {
            icon: 'barChart',
            title: 'Analyses Avancées',
            description: 'Compréhension approfondie des performances de votre boutique'
          }
        ]
      },
      availableService: {
        title: 'Service Disponible 24h/24',
        description: 'Équipe de support professionnelle prête à vous aider à tout moment',
        services: [
          {
            title: 'Support Technique 24/7',
            description: 'Notre équipe est toujours disponible pour répondre à vos questions et vous aider'
          },
          {
            title: 'Centre de Formation Complet',
            description: 'Bibliothèque riche de tutoriels et leçons illustrées'
          },
          {
            title: 'Communauté Active',
            description: 'Rejoignez des milliers de marchands et échangez des expériences'
          }
        ],
        supportTitle: 'Nous Sommes Là pour Vous Aider',
        supportDescription: 'Contactez-nous par chat, téléphone ou email',
        contactButton: 'Contactez-nous Maintenant'
      },
      professionalManagement: {
        title: 'Maîtrisez la Gestion de Votre Boutique',
        subtitle: 'Outils professionnels pour gérer efficacement tous les aspects de votre boutique',
        tools: [
          {
            title: 'Gestion des Produits',
            description: 'Ajoutez et modifiez vos produits facilement avec une gestion avancée des stocks',
            features: [
              'Ajout de produits illimités',
              'Catégories et tags intelligents',
              'Gestion automatique des stocks',
              'Import en masse'
            ]
          },
          {
            title: 'Gestion des Commandes',
            description: 'Suivez et traitez les commandes avec une grande efficacité',
            features: [
              'Système de commandes avancé',
              'Notifications instantanées',
              'Suivi des expéditions',
              'Gestion des retours'
            ]
          },
          {
            title: 'Gestion des Clients',
            description: 'Construisez des relations solides avec vos clients',
            features: [
              'Base de données complète',
              'Historique complet des commandes',
              'Programmes de fidélité',
              'Segmentation des clients'
            ]
          }
        ]
      },
      successSteps: {
        title: 'Étapes du Succès',
        subtitle: 'Suivez ces étapes simples pour lancer votre boutique à succès',
        steps: [
          {
            title: 'Créer un Compte',
            description: 'Créez un compte gratuit en secondes'
          },
          {
            title: 'Concevoir la Boutique',
            description: 'Choisissez un modèle et personnalisez-le'
          },
          {
            title: 'Ajouter Produits',
            description: 'Téléchargez les produits et définissez les prix'
          },
          {
            title: 'Commencer à Vendre',
            description: 'Lancez la boutique et recevez des commandes'
          }
        ]
      },
      customerData: {
        title: 'Collectez les Données Clients Intelligemment',
        description: 'Une compréhension approfondie du comportement des clients vous aide à améliorer les ventes et l\'expérience d\'achat',
        benefits: [
          'Analyse complète du comportement des clients',
          'Suivi complet du parcours d\'achat',
          'Rapports détaillés sur les intérêts',
          'Recommandations intelligentes de produits'
        ],
        metric1: 'Clients Actifs',
        metric2: 'Croissance Clients',
        metric3: 'Taux de Satisfaction'
      },
      successTools: {
        title: 'Outils de Succès à Portée de Main',
        subtitle: 'Tout ce dont vous avez besoin pour développer votre boutique et augmenter les ventes',
        tools: [
          {
            icon: 'zap',
            title: 'Marketing Intelligent',
            description: 'Outils marketing avancés pour attirer plus de clients et augmenter les ventes'
          },
          {
            icon: 'target',
            title: 'Campagnes Ciblées',
            description: 'Créez des campagnes marketing précises qui atteignent le bon public au bon moment'
          },
          {
            icon: 'trendingUp',
            title: 'Optimisation SEO',
            description: 'Outils SEO avancés pour une meilleure visibilité dans les résultats de recherche'
          },
          {
            icon: 'shield',
            title: 'Sécurité Garantie',
            description: 'Protection multicouche pour votre boutique et les données clients'
          },
          {
            icon: 'users',
            title: 'Gestion d\'Équipe',
            description: 'Ajoutez des membres de l\'équipe et définissez les permissions facilement'
          },
          {
            icon: 'rocket',
            title: 'Croissance Continue',
            description: 'Outils et mises à jour continues pour vous aider à grandir'
          }
        ]
      },
      pricingPreview: {
        title: 'Plans Flexibles pour Tous les Besoins',
        subtitle: 'Commencez gratuitement et évoluez au fur et à mesure de la croissance de votre boutique',
        popularBadge: 'Le Plus Populaire',
        plans: [
          {
            name: 'Débutant',
            price: 'Gratuit',
            features: [
              'Jusqu\'à 50 produits',
              'Sous-domaine gratuit',
              'Support de base',
              'Rapports de base'
            ],
            cta: 'Commencer Gratuitement',
            popular: false
          },
          {
            name: 'Professionnel',
            price: '2,500 DZD/mois',
            features: [
              'Produits illimités',
              'Domaine personnalisé gratuit',
              'Support 24/7',
              'Analyses avancées',
              'Application mobile'
            ],
            cta: 'Essayer Maintenant',
            popular: true
          },
          {
            name: 'Enterprise',
            price: 'Sur Mesure',
            features: [
              'Toutes les fonctionnalités Pro',
              'Gestionnaire de compte dédié',
              'Intégration personnalisée',
              'Sans commission'
            ],
            cta: 'Contactez-nous',
            popular: false
          }
        ],
        viewAll: 'Voir Tous les Plans'
      },
      finalCta: {
        title: 'Prêt à Lancer Votre Boutique?',
        subtitle: 'Rejoignez des milliers de marchands qui ont choisi eCommaps pour construire leurs boutiques en ligne à succès',
        primaryButton: 'Créez Votre Boutique Maintenant',
        secondaryButton: 'En Savoir Plus'
      }
    },
    pos: {
      hero: {
        badge: 'Système de Point de Vente Complet',
        title: 'Transformez Votre Magasin Traditionnel en Expérience Numérique Intégrée',
        subtitle: 'Système de caisse professionnel intégré à votre boutique en ligne - Gestion unifiée des stocks et des ventes',
        primaryButton: 'Commencez Votre Essai Gratuit',
        secondaryButton: 'Voir la Démo',
        stats: [
          { value: '3', label: 'Minutes d\'Installation' },
          { value: '100%', label: 'Synchro Auto' },
          { value: '24/7', label: 'Support Technique' },
          { value: '0 DA', label: 'Frais de Configuration' }
        ]
      },
      whyNeed: {
        title: 'Pourquoi Avez-Vous Besoin du POS de eCommaps?',
        subtitle: 'Un système intégré combinant la puissance du commerce électronique et la facilité du POS traditionnel',
        features: [
          {
            title: 'Synchronisation Instantanée avec la Boutique en Ligne',
            description: 'Chaque vente en magasin se reflète directement sur votre inventaire en ligne'
          },
          {
            title: 'Gestion Unifiée des Stocks',
            description: 'Plus d\'erreurs - un inventaire synchronisé sur tous les points de vente'
          },
          {
            title: 'Rapports Complets et Détaillés',
            description: 'Analyses précises de vos ventes en magasin et en ligne depuis un seul tableau de bord'
          },
          {
            title: 'Support de Multiples Méthodes de Paiement',
            description: 'Espèces, cartes, portefeuille électronique - tout en un seul endroit'
          }
        ]
      },
      features: {
        title: 'Fonctionnalités du Système POS',
        subtitle: 'Tout ce dont vous avez besoin pour gérer votre magasin traditionnel professionnellement',
        items: [
          {
            title: 'Interface Facile à Utiliser',
            description: 'Design simple et rapide que votre personnel peut maîtriser en quelques minutes'
          },
          {
            title: 'Impression de Factures Professionnelles',
            description: 'Factures personnalisées avec votre logo et informations commerciales'
          },
          {
            title: 'Gestion des Clients',
            description: 'Enregistrez les données clients, programmes de fidélité et remises spéciales'
          },
          {
            title: 'Lecteur de Code-Barres',
            description: 'Support complet des lecteurs de codes-barres pour scanner les produits rapidement'
          },
          {
            title: 'Rapports Quotidiens et Mensuels',
            description: 'Rapports détaillés sur les ventes, les bénéfices et les stocks'
          },
          {
            title: 'Mode Hors Ligne',
            description: 'Continuez à vendre sans internet - synchronisation automatique au retour'
          }
        ]
      },
      howToUse: {
        title: 'Comment Commencer à Utiliser le Système POS?',
        subtitle: 'Quatre étapes simples pour activer votre point de vente',
        steps: [
          {
            title: 'Téléchargez l\'Application',
            description: 'Disponible sur Web, Windows et Android'
          },
          {
            title: 'Liez Votre Compte',
            description: 'Connectez-vous avec votre compte de boutique en ligne'
          },
          {
            title: 'Configurez les Paramètres',
            description: 'Choisissez l\'imprimante, le mode de paiement et les taxes'
          },
          {
            title: 'Commencez à Vendre',
            description: 'Tout est prêt - commencez à accueillir vos clients'
          }
        ]
      },
      storeTypes: {
        title: 'Adapté à Tous les Types de Magasins',
        subtitle: 'Un système flexible qui s\'adapte aux besoins de votre entreprise',
        types: [
          {
            title: 'Magasins de Vêtements',
            description: 'Gérez facilement les tailles, couleurs et modèles'
          },
          {
            title: 'Magasins d\'Électronique',
            description: 'Suivez les numéros de série et les garanties'
          },
          {
            title: 'Cafés et Restaurants',
            description: 'Menus alimentaires et options de personnalisation des commandes'
          },
          {
            title: 'Pharmacies',
            description: 'Suivez les dates d\'expiration et les prescriptions'
          },
          {
            title: 'Boutiques de Cadeaux',
            description: 'Options d\'emballage et de cartes'
          },
          {
            title: 'Tout Autre Type',
            description: 'Système flexible personnalisable selon vos besoins'
          }
        ]
      },
      integration: {
        title: 'Intégration Transparente avec Votre Boutique en Ligne',
        subtitle: 'Un système pour gérer tous les canaux de vente',
        benefits: [
          'Inventaire unifié mis à jour automatiquement',
          'Rapports complets pour tous les canaux',
          'Données clients centralisées',
          'Méthodes de paiement unifiées',
          'Campagnes marketing intégrées',
          'Programmes de fidélité unifiés'
        ]
      },
      pricing: {
        title: 'Plans Tarifaires du Système POS',
        subtitle: 'Choisissez le plan adapté à la taille de votre entreprise',
        plans: [
          {
            name: 'Plan Basique',
            price: 'Gratuit',
            period: 'mensuel',
            description: 'Parfait pour les petits magasins',
            features: [
              'Un point de vente',
              'Produits illimités',
              'Synchronisation avec boutique en ligne',
              'Rapports de base',
              'Support technique'
            ]
          },
          {
            name: 'Plan Avancé',
            price: '4,999',
            period: 'mensuel',
            description: 'Pour les magasins moyens',
            popular: true,
            features: [
              'Jusqu\'à 5 points de vente',
              'Toutes les fonctionnalités du Plan Basique',
              'Rapports avancés',
              'Gestion du personnel',
              'Programmes de fidélité',
              'Support de code-barres'
            ]
          },
          {
            name: 'Plan Professionnel',
            price: 'Sur Mesure',
            period: '',
            description: 'Pour les grands magasins',
            features: [
              'Points de vente illimités',
              'Toutes les fonctionnalités Avancées',
              'API personnalisée',
              'Gestionnaire de compte dédié',
              'Formation de l\'équipe',
              'Support VIP'
            ]
          }
        ]
      },
      testimonials: {
        title: 'Ce Que Disent Nos Clients',
        items: [
          {
            name: 'Ahmed Ben Mohamed',
            role: 'Propriétaire de Magasin de Vêtements',
            text: 'Le système POS de eCommaps a complètement changé ma façon de travailler. Maintenant je contrôle tout depuis un seul endroit.'
          },
          {
            name: 'Fatima Zahra',
            role: 'Propriétaire de Magasin d\'Électronique',
            text: 'La synchronisation instantanée avec la boutique en ligne m\'a fait gagner beaucoup de temps et d\'erreurs.'
          },
          {
            name: 'Khaled Al Arabi',
            role: 'Propriétaire de Café',
            text: 'Facile à utiliser et rapide. Mon personnel l\'a appris en moins d\'une heure.'
          }
        ]
      },
      hardware: {
        title: 'Appareils Supportés',
        subtitle: 'Fonctionne avec la plupart des appareils POS disponibles sur le marché',
        devices: [
          {
            title: 'Imprimantes de Reçus',
            description: 'Support pour toutes les imprimantes thermiques 80mm et 58mm'
          },
          {
            title: 'Lecteurs de Code-Barres',
            description: 'Compatible avec tous les lecteurs USB et Bluetooth'
          },
          {
            title: 'Tiroirs-Caisses',
            description: 'S\'ouvre automatiquement après chaque vente en espèces'
          },
          {
            title: 'Terminaux de Paiement',
            description: 'Intégré aux terminaux de paiement électronique populaires'
          }
        ]
      },
      finalCta: {
        title: 'Prêt à Transformer Votre Magasin en Expérience Numérique?',
        subtitle: 'Commencez votre essai gratuit aujourd\'hui, aucune carte de crédit requise',
        primaryButton: 'Commencez Votre Essai Gratuit',
        secondaryButton: 'Parler à un Expert'
      }
    }
  }
};

export function getDirection(lang: Language): 'rtl' | 'ltr' {
  return lang === 'ar' ? 'rtl' : 'ltr';
}
